//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.6.10.0 (Newtonsoft.Json v11.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export class RequirementsExtensionElement implements IRequirementsExtensionElement {
    capabilities!: Capabilities[];
    /** Identifies the scopes in which the add-in can run. */
    scopes!: Scopes[];
    /** Identifies the form factors that support the add-in. Supported values: mobile, desktop. */
    formFactors!: FormFactors[];

    constructor(data?: IRequirementsExtensionElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["capabilities"])) {
                this.capabilities = [] as any;
                for (let item of _data["capabilities"])
                    this.capabilities!.push(Capabilities.fromJS(item));
            }
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            if (Array.isArray(_data["formFactors"])) {
                this.formFactors = [] as any;
                for (let item of _data["formFactors"])
                    this.formFactors!.push(item);
            }
        }
    }

    static fromJS(data: any): RequirementsExtensionElement {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementsExtensionElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.capabilities)) {
            data["capabilities"] = [];
            for (let item of this.capabilities)
                data["capabilities"].push(item.toJSON());
        }
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        if (Array.isArray(this.formFactors)) {
            data["formFactors"] = [];
            for (let item of this.formFactors)
                data["formFactors"].push(item);
        }
        return data;
    }
}

export interface IRequirementsExtensionElement {
    capabilities: Capabilities[];
    /** Identifies the scopes in which the add-in can run. */
    scopes: Scopes[];
    /** Identifies the form factors that support the add-in. Supported values: mobile, desktop. */
    formFactors: FormFactors[];
}

export class ExtensionRuntimesActionsItem implements IExtensionRuntimesActionsItem {
    /** Identifier for this action. Maximum length is 64 characters. This value is passed to the code file. */
    id!: string;
    /** executeFunction: Run a script function without waiting for it to finish. openPate: Open a page in a view. */
    type!: ExtensionRuntimesActionsItemType;
    /** Display name of the action. Maximum length is 64 characters. */
    displayName!: string;
    /** Specifies that a task pane supports pinning, which keeps the task pane open when the user changes the selection. */
    pinnable!: boolean;
    /** View where the page should be opened. Maximum length is 64 characters.   */
    view!: string;
    /** Whether allows the action to have multiple selection. */
    multiselect!: boolean;
    /** Whether allows task pane add-ins to activate without the Reading Pane enabled or a message selected.  */
    supportsNoItemContext!: boolean;

    constructor(data?: IExtensionRuntimesActionsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.multiselect = false;
            this.supportsNoItemContext = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.displayName = _data["displayName"];
            this.pinnable = _data["pinnable"];
            this.view = _data["view"];
            this.multiselect = _data["multiselect"] !== undefined ? _data["multiselect"] : false;
            this.supportsNoItemContext = _data["supportsNoItemContext"] !== undefined ? _data["supportsNoItemContext"] : false;
        }
    }

    static fromJS(data: any): ExtensionRuntimesActionsItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionRuntimesActionsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["displayName"] = this.displayName;
        data["pinnable"] = this.pinnable;
        data["view"] = this.view;
        data["multiselect"] = this.multiselect;
        data["supportsNoItemContext"] = this.supportsNoItemContext;
        return data;
    }
}

export interface IExtensionRuntimesActionsItem {
    /** Identifier for this action. Maximum length is 64 characters. This value is passed to the code file. */
    id: string;
    /** executeFunction: Run a script function without waiting for it to finish. openPate: Open a page in a view. */
    type: ExtensionRuntimesActionsItemType;
    /** Display name of the action. Maximum length is 64 characters. */
    displayName: string;
    /** Specifies that a task pane supports pinning, which keeps the task pane open when the user changes the selection. */
    pinnable: boolean;
    /** View where the page should be opened. Maximum length is 64 characters.   */
    view: string;
    /** Whether allows the action to have multiple selection. */
    multiselect: boolean;
    /** Whether allows task pane add-ins to activate without the Reading Pane enabled or a message selected.  */
    supportsNoItemContext: boolean;
}

export class ExtensionRibbonsArrayTabsItem implements IExtensionRibbonsArrayTabsItem {
    /** A unique identifier for this tab within the app. Maximum length is 64 characters.  */
    id!: string;
    /** Displayed text for the tab. Maximum length is 64 characters. */
    label!: string;
    position!: Position;
    /** Id of the existing office Tab. Maximum length is 64 characters. */
    builtInTabId!: string;
    /** Defines tab groups. */
    groups!: ExtensionRibbonsCustomTabGroupsItem[];
    /** Defines mobile group item. */
    customMobileRibbonGroups!: ExtensionRibbonsCustomMobileGroupItem[];

    constructor(data?: IExtensionRibbonsArrayTabsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : <any>undefined;
            this.builtInTabId = _data["builtInTabId"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(ExtensionRibbonsCustomTabGroupsItem.fromJS(item));
            }
            if (Array.isArray(_data["customMobileRibbonGroups"])) {
                this.customMobileRibbonGroups = [] as any;
                for (let item of _data["customMobileRibbonGroups"])
                    this.customMobileRibbonGroups!.push(ExtensionRibbonsCustomMobileGroupItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtensionRibbonsArrayTabsItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionRibbonsArrayTabsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["builtInTabId"] = this.builtInTabId;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.customMobileRibbonGroups)) {
            data["customMobileRibbonGroups"] = [];
            for (let item of this.customMobileRibbonGroups)
                data["customMobileRibbonGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtensionRibbonsArrayTabsItem {
    /** A unique identifier for this tab within the app. Maximum length is 64 characters.  */
    id: string;
    /** Displayed text for the tab. Maximum length is 64 characters. */
    label: string;
    position: Position;
    /** Id of the existing office Tab. Maximum length is 64 characters. */
    builtInTabId: string;
    /** Defines tab groups. */
    groups: ExtensionRibbonsCustomTabGroupsItem[];
    /** Defines mobile group item. */
    customMobileRibbonGroups: ExtensionRibbonsCustomMobileGroupItem[];
}

export class ExtensionRibbonsCustomTabGroupsItem implements IExtensionRibbonsCustomTabGroupsItem {
    /** A unique identifier for this group within the app. Maximum length is 64 characters.  */
    id!: string;
    /** Displayed text for the group. Maximum length is 64 characters. */
    label!: string;
    icons!: ExtensionCommonIcon[];
    controls!: ExtensionCommonCustomGroupControlsItem[];
    /** Id of a built-in Group. Maximum length is 64 characters. */
    builtInGroupId!: string;

    constructor(data?: IExtensionRibbonsCustomTabGroupsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(ExtensionCommonIcon.fromJS(item));
            }
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(ExtensionCommonCustomGroupControlsItem.fromJS(item));
            }
            this.builtInGroupId = _data["builtInGroupId"];
        }
    }

    static fromJS(data: any): ExtensionRibbonsCustomTabGroupsItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionRibbonsCustomTabGroupsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item.toJSON());
        }
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item.toJSON());
        }
        data["builtInGroupId"] = this.builtInGroupId;
        return data;
    }
}

export interface IExtensionRibbonsCustomTabGroupsItem {
    /** A unique identifier for this group within the app. Maximum length is 64 characters.  */
    id: string;
    /** Displayed text for the group. Maximum length is 64 characters. */
    label: string;
    icons: ExtensionCommonIcon[];
    controls: ExtensionCommonCustomGroupControlsItem[];
    /** Id of a built-in Group. Maximum length is 64 characters. */
    builtInGroupId: string;
}

export class ExtensionCommonCustomGroup implements IExtensionCommonCustomGroup {
    /** A unique identifier for this group within the app. Maximum length is 64 characters.  */
    id!: string;
    /** Displayed text for the group. Maximum length is 64 characters. */
    label!: string;
    /** Displayed icons for the group. */
    icons!: ExtensionCommonIcon[];
    /** Configures the buttons and menus in the group. */
    controls!: ExtensionCommonCustomGroupControlsItem[];

    constructor(data?: IExtensionCommonCustomGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.controls = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(ExtensionCommonIcon.fromJS(item));
            }
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(ExtensionCommonCustomGroupControlsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtensionCommonCustomGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCommonCustomGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item.toJSON());
        }
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtensionCommonCustomGroup {
    /** A unique identifier for this group within the app. Maximum length is 64 characters.  */
    id: string;
    /** Displayed text for the group. Maximum length is 64 characters. */
    label: string;
    /** Displayed icons for the group. */
    icons: ExtensionCommonIcon[];
    /** Configures the buttons and menus in the group. */
    controls: ExtensionCommonCustomGroupControlsItem[];
}

export class ExtensionCommonCustomGroupControlsItem implements IExtensionCommonCustomGroupControlsItem {
    /** A unique identifier for this control within the app. Maximum length is 64 characters.  */
    id!: string;
    /** Defines the type of control whether button or menu. */
    type!: ExtensionCommonCustomGroupControlsItemType;
    /** Id of the existing office control. Maximum length is 64 characters. */
    builtInControlId!: string;
    /** Displayed text for the control. Maximum length is 64 characters. */
    label!: string;
    icons!: ExtensionCommonIcon[];
    supertip!: ExtensionCommonSuperToolTip;
    /** The ID of an execution-type action that handles this key combination. Maximum length is 64 characters. */
    actionId!: string;
    /** Specifies whether a group, button, menu, or menu item will be hidden on application and platform combinations that support the API (Office.ribbon.requestCreateControls) that installs custom contextual tabs on the ribbon. Default is false. */
    overriddenByRibbonApi!: boolean;
    /** Whether the control is initially enabled. */
    enabled!: boolean;
    /** Configures the items for a menu control. */
    items!: ExtensionCommonCustomControlMenuItem[];

    constructor(data?: IExtensionCommonCustomGroupControlsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.icons = [];
            this.supertip = new ExtensionCommonSuperToolTip();
            this.overriddenByRibbonApi = false;
            this.enabled = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.builtInControlId = _data["builtInControlId"];
            this.label = _data["label"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(ExtensionCommonIcon.fromJS(item));
            }
            this.supertip = _data["supertip"] ? ExtensionCommonSuperToolTip.fromJS(_data["supertip"]) : new ExtensionCommonSuperToolTip();
            this.actionId = _data["actionId"];
            this.overriddenByRibbonApi = _data["overriddenByRibbonApi"] !== undefined ? _data["overriddenByRibbonApi"] : false;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : true;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExtensionCommonCustomControlMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtensionCommonCustomGroupControlsItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCommonCustomGroupControlsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["builtInControlId"] = this.builtInControlId;
        data["label"] = this.label;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item.toJSON());
        }
        data["supertip"] = this.supertip ? this.supertip.toJSON() : <any>undefined;
        data["actionId"] = this.actionId;
        data["overriddenByRibbonApi"] = this.overriddenByRibbonApi;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtensionCommonCustomGroupControlsItem {
    /** A unique identifier for this control within the app. Maximum length is 64 characters.  */
    id: string;
    /** Defines the type of control whether button or menu. */
    type: ExtensionCommonCustomGroupControlsItemType;
    /** Id of the existing office control. Maximum length is 64 characters. */
    builtInControlId: string;
    /** Displayed text for the control. Maximum length is 64 characters. */
    label: string;
    icons: ExtensionCommonIcon[];
    supertip: ExtensionCommonSuperToolTip;
    /** The ID of an execution-type action that handles this key combination. Maximum length is 64 characters. */
    actionId: string;
    /** Specifies whether a group, button, menu, or menu item will be hidden on application and platform combinations that support the API (Office.ribbon.requestCreateControls) that installs custom contextual tabs on the ribbon. Default is false. */
    overriddenByRibbonApi: boolean;
    /** Whether the control is initially enabled. */
    enabled: boolean;
    /** Configures the items for a menu control. */
    items: ExtensionCommonCustomControlMenuItem[];
}

export class ExtensionRibbonsCustomMobileGroupItem implements IExtensionRibbonsCustomMobileGroupItem {
    /** Specify the Id of the group. Used for mobileMessageRead ext point. */
    id!: string;
    /** Short label of the control. Maximum length is 32 characters. */
    label!: string;
    controls!: ExtensionRibbonsCustomMobileControlButtonItem[];

    constructor(data?: IExtensionRibbonsCustomMobileGroupItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.controls = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(ExtensionRibbonsCustomMobileControlButtonItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtensionRibbonsCustomMobileGroupItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionRibbonsCustomMobileGroupItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtensionRibbonsCustomMobileGroupItem {
    /** Specify the Id of the group. Used for mobileMessageRead ext point. */
    id: string;
    /** Short label of the control. Maximum length is 32 characters. */
    label: string;
    controls: ExtensionRibbonsCustomMobileControlButtonItem[];
}

export class ExtensionCommonCustomControlMenu implements IExtensionCommonCustomControlMenu {
    /** A unique identifier for this control within the app. Maximum length is 64 characters.  */
    id!: string;
    type!: ExtensionCommonCustomControlMenuType;
    /** Displayed text for the control. Maximum length is 64 characters. */
    label!: string;
    icons!: ExtensionCommonIcon[];
    supertip!: ExtensionCommonSuperToolTip;
    items!: ExtensionCommonCustomControlMenuItem[];
    /** Specifies whether a group, button, menu, or menu item will be hidden on application and platform combinations that support the API (Office.ribbon.requestCreateControls) that installs custom contextual tabs on the ribbon. Default is false. */
    overriddenByRibbonApi!: boolean;

    constructor(data?: IExtensionCommonCustomControlMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.icons = [];
            this.supertip = new ExtensionCommonSuperToolTip();
            this.items = [];
            this.overriddenByRibbonApi = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.label = _data["label"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(ExtensionCommonIcon.fromJS(item));
            }
            this.supertip = _data["supertip"] ? ExtensionCommonSuperToolTip.fromJS(_data["supertip"]) : new ExtensionCommonSuperToolTip();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExtensionCommonCustomControlMenuItem.fromJS(item));
            }
            this.overriddenByRibbonApi = _data["overriddenByRibbonApi"] !== undefined ? _data["overriddenByRibbonApi"] : false;
        }
    }

    static fromJS(data: any): ExtensionCommonCustomControlMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCommonCustomControlMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["label"] = this.label;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item.toJSON());
        }
        data["supertip"] = this.supertip ? this.supertip.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["overriddenByRibbonApi"] = this.overriddenByRibbonApi;
        return data;
    }
}

export interface IExtensionCommonCustomControlMenu {
    /** A unique identifier for this control within the app. Maximum length is 64 characters.  */
    id: string;
    type: ExtensionCommonCustomControlMenuType;
    /** Displayed text for the control. Maximum length is 64 characters. */
    label: string;
    icons: ExtensionCommonIcon[];
    supertip: ExtensionCommonSuperToolTip;
    items: ExtensionCommonCustomControlMenuItem[];
    /** Specifies whether a group, button, menu, or menu item will be hidden on application and platform combinations that support the API (Office.ribbon.requestCreateControls) that installs custom contextual tabs on the ribbon. Default is false. */
    overriddenByRibbonApi: boolean;
}

export class ExtensionCommonCustomControlMenuItem implements IExtensionCommonCustomControlMenuItem {
    /** A unique identifier for this control within the app. Maximum length is 64 characters.  */
    id!: string;
    /** Supported values: menuItem. */
    type!: ExtensionCommonCustomControlMenuItemType;
    /** Displayed text for the control. Maximum length is 64 characters. */
    label!: string;
    icons!: ExtensionCommonIcon[];
    supertip!: ExtensionCommonSuperToolTip;
    /** The ID of an action defined in runtimes. Maximum length is 64 characters. */
    actionId!: string;
    /** Whether the control is initially enabled. */
    enabled!: boolean;
    overriddenByRibbonApi!: boolean;

    constructor(data?: IExtensionCommonCustomControlMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.supertip = new ExtensionCommonSuperToolTip();
            this.enabled = true;
            this.overriddenByRibbonApi = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.label = _data["label"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(ExtensionCommonIcon.fromJS(item));
            }
            this.supertip = _data["supertip"] ? ExtensionCommonSuperToolTip.fromJS(_data["supertip"]) : new ExtensionCommonSuperToolTip();
            this.actionId = _data["actionId"];
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : true;
            this.overriddenByRibbonApi = _data["overriddenByRibbonApi"] !== undefined ? _data["overriddenByRibbonApi"] : false;
        }
    }

    static fromJS(data: any): ExtensionCommonCustomControlMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCommonCustomControlMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["label"] = this.label;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item.toJSON());
        }
        data["supertip"] = this.supertip ? this.supertip.toJSON() : <any>undefined;
        data["actionId"] = this.actionId;
        data["enabled"] = this.enabled;
        data["overriddenByRibbonApi"] = this.overriddenByRibbonApi;
        return data;
    }
}

export interface IExtensionCommonCustomControlMenuItem {
    /** A unique identifier for this control within the app. Maximum length is 64 characters.  */
    id: string;
    /** Supported values: menuItem. */
    type: ExtensionCommonCustomControlMenuItemType;
    /** Displayed text for the control. Maximum length is 64 characters. */
    label: string;
    icons: ExtensionCommonIcon[];
    supertip: ExtensionCommonSuperToolTip;
    /** The ID of an action defined in runtimes. Maximum length is 64 characters. */
    actionId: string;
    /** Whether the control is initially enabled. */
    enabled: boolean;
    overriddenByRibbonApi: boolean;
}

export class ExtensionRibbonsCustomMobileControlButtonItem implements IExtensionRibbonsCustomMobileControlButtonItem {
    /** Specify the Id of the button like msgReadFunctionButton. */
    id!: string;
    type!: ExtensionRibbonsCustomMobileControlButtonItemType;
    /** Short label of the control. Maximum length is 32 characters. */
    label!: string;
    icons!: ExtensionCustomMobileIcon[];
    /** The ID of an action defined in runtimes. Maximum length is 64 characters. */
    actionId!: string;

    constructor(data?: IExtensionRibbonsCustomMobileControlButtonItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.icons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.label = _data["label"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(ExtensionCustomMobileIcon.fromJS(item));
            }
            this.actionId = _data["actionId"];
        }
    }

    static fromJS(data: any): ExtensionRibbonsCustomMobileControlButtonItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionRibbonsCustomMobileControlButtonItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["label"] = this.label;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item.toJSON());
        }
        data["actionId"] = this.actionId;
        return data;
    }
}

export interface IExtensionRibbonsCustomMobileControlButtonItem {
    /** Specify the Id of the button like msgReadFunctionButton. */
    id: string;
    type: ExtensionRibbonsCustomMobileControlButtonItemType;
    /** Short label of the control. Maximum length is 32 characters. */
    label: string;
    icons: ExtensionCustomMobileIcon[];
    /** The ID of an action defined in runtimes. Maximum length is 64 characters. */
    actionId: string;
}

export class ExtensionCustomMobileIcon implements IExtensionCustomMobileIcon {
    /** Size in pixels of the icon. Three image sizes are required (25, 32, and 48 pixels). */
    size!: number;
    /** Url to the icon. */
    url!: string;
    /** How to scale - 1,2,3 for each image. This attribute specifies the UIScreen.scale property for iOS devices. */
    scale!: number;

    constructor(data?: IExtensionCustomMobileIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.size = _data["size"];
            this.url = _data["url"];
            this.scale = _data["scale"];
        }
    }

    static fromJS(data: any): ExtensionCustomMobileIcon {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCustomMobileIcon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["url"] = this.url;
        data["scale"] = this.scale;
        return data;
    }
}

export interface IExtensionCustomMobileIcon {
    /** Size in pixels of the icon. Three image sizes are required (25, 32, and 48 pixels). */
    size: number;
    /** Url to the icon. */
    url: string;
    /** How to scale - 1,2,3 for each image. This attribute specifies the UIScreen.scale property for iOS devices. */
    scale: number;
}

export class ExtensionCommonSuperToolTip implements IExtensionCommonSuperToolTip {
    /** Title text of the super tip. Maximum length is 64 characters. */
    title!: string;
    /** Description of the super tip. Maximum length is 250 characters. */
    description!: string;

    constructor(data?: IExtensionCommonSuperToolTip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ExtensionCommonSuperToolTip {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCommonSuperToolTip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface IExtensionCommonSuperToolTip {
    /** Title text of the super tip. Maximum length is 64 characters. */
    title: string;
    /** Description of the super tip. Maximum length is 250 characters. */
    description: string;
}

export class ExtensionCommonIcon implements IExtensionCommonIcon {
    /** Size in pixels of the icon. Three image sizes are required (16, 32, and 80 pixels) */
    size!: number;
    /** Absolute Url to the icon. */
    url!: string;

    constructor(data?: IExtensionCommonIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.size = _data["size"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ExtensionCommonIcon {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionCommonIcon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["url"] = this.url;
        return data;
    }
}

export interface IExtensionCommonIcon {
    /** Size in pixels of the icon. Three image sizes are required (16, 32, and 80 pixels) */
    size: number;
    /** Absolute Url to the icon. */
    url: string;
}

export class ExtensionRuntimeCode implements IExtensionRuntimeCode {
    /** URL of the .html page to be loaded in browser-based runtimes. */
    page!: string;
    /** URL of the .js script file to be loaded in UI-less runtimes. */
    script!: string;

    constructor(data?: IExtensionRuntimeCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.script = _data["script"];
        }
    }

    static fromJS(data: any): ExtensionRuntimeCode {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionRuntimeCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["script"] = this.script;
        return data;
    }
}

export interface IExtensionRuntimeCode {
    /** URL of the .html page to be loaded in browser-based runtimes. */
    page: string;
    /** URL of the .js script file to be loaded in UI-less runtimes. */
    script: string;
}

/** Cards wich could be pinned to dashboard providing summarized view of information relevant to user. */
export class DashboardCard implements IDashboardCard {
    /** Unique Id for the card. Must be unique inside the app. */
    id!: string;
    /** Represents the name of the card. Maximum length is 255 characters. */
    displayName!: string;
    /** Description of the card.Maximum length is 255 characters. */
    description!: string;
    /** Id of the group in the card picker. This must be guid. */
    pickerGroupId!: string;
    icon!: DashboardCardIcon;
    contentSource!: DashboardCardContentSource;
    /** Rendering Size for dashboard card. */
    defaultSize!: DashboardCardDefaultSize;

    constructor(data?: IDashboardCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contentSource = new DashboardCardContentSource();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.pickerGroupId = _data["pickerGroupId"];
            this.icon = _data["icon"] ? DashboardCardIcon.fromJS(_data["icon"]) : <any>undefined;
            this.contentSource = _data["contentSource"] ? DashboardCardContentSource.fromJS(_data["contentSource"]) : new DashboardCardContentSource();
            this.defaultSize = _data["defaultSize"];
        }
    }

    static fromJS(data: any): DashboardCard {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["pickerGroupId"] = this.pickerGroupId;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["contentSource"] = this.contentSource ? this.contentSource.toJSON() : <any>undefined;
        data["defaultSize"] = this.defaultSize;
        return data;
    }
}

/** Cards wich could be pinned to dashboard providing summarized view of information relevant to user. */
export interface IDashboardCard {
    /** Unique Id for the card. Must be unique inside the app. */
    id: string;
    /** Represents the name of the card. Maximum length is 255 characters. */
    displayName: string;
    /** Description of the card.Maximum length is 255 characters. */
    description: string;
    /** Id of the group in the card picker. This must be guid. */
    pickerGroupId: string;
    icon: DashboardCardIcon;
    contentSource: DashboardCardContentSource;
    /** Rendering Size for dashboard card. */
    defaultSize: DashboardCardDefaultSize;
}

/** Represents a configuration for the source of the card’s content */
export class DashboardCardIcon implements IDashboardCardIcon {
    /** The icon for the card, to be displayed in the toolbox and card bar, represented as URL. */
    iconUrl!: string;
    /** Office UI Fabric/Fluent UI icon friendly name for the card. This value will be used if ‘iconUrl’ is not specified. */
    officeUIFabricIconName!: string;

    constructor(data?: IDashboardCardIcon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iconUrl = _data["iconUrl"];
            this.officeUIFabricIconName = _data["officeUIFabricIconName"];
        }
    }

    static fromJS(data: any): DashboardCardIcon {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCardIcon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconUrl"] = this.iconUrl;
        data["officeUIFabricIconName"] = this.officeUIFabricIconName;
        return data;
    }
}

/** Represents a configuration for the source of the card’s content */
export interface IDashboardCardIcon {
    /** The icon for the card, to be displayed in the toolbox and card bar, represented as URL. */
    iconUrl: string;
    /** Office UI Fabric/Fluent UI icon friendly name for the card. This value will be used if ‘iconUrl’ is not specified. */
    officeUIFabricIconName: string;
}

/** Represents a configuration for the source of the card’s content. */
export class DashboardCardContentSource implements IDashboardCardContentSource {
    /** The content of the dashboard card is sourced from a bot. */
    sourceType!: DashboardCardContentSourceSourceType;
    /** The configuration for the bot source. Required if sourceType is set to bot. */
    botConfiguration!: BotConfiguration;

    constructor(data?: IDashboardCardContentSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
            this.botConfiguration = _data["botConfiguration"] ? BotConfiguration.fromJS(_data["botConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardCardContentSource {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCardContentSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["botConfiguration"] = this.botConfiguration ? this.botConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents a configuration for the source of the card’s content. */
export interface IDashboardCardContentSource {
    /** The content of the dashboard card is sourced from a bot. */
    sourceType: DashboardCardContentSourceSourceType;
    /** The configuration for the bot source. Required if sourceType is set to bot. */
    botConfiguration: BotConfiguration;
}

export class MosManifest implements IMosManifest {
    $schema!: string;
    /** The version of the schema this manifest is using. This schema version supports extending Teams apps to other parts of the Microsoft 365 ecosystem. More info at https://aka.ms/extendteamsapps. */
    manifestVersion!: string;
    /** The version of the app. Changes to your manifest should cause a version change. This version string must follow the semver standard (http://semver.org). */
    version!: string;
    /** A unique identifier for this app. This id must be a GUID. */
    id!: string;
    localizationInfo!: LocalizationInfo;
    developer!: Developer;
    name!: Name;
    description!: Description;
    icons!: Icons;
    /** A color to use in conjunction with the icon. The value must be a valid HTML color code starting with '#', for example `#4464ee`. */
    accentColor!: string;
    /** These are tabs users can optionally add to their channels and 1:1 or group chats and require extra configuration before they are added. Configurable tabs are not supported in the personal scope. Currently only one configurable tab per app is supported. */
    configurableTabs!: ConfigurableTabs[];
    /** A set of tabs that may be 'pinned' by default, without the user adding them manually. Static tabs declared in personal scope are always pinned to the app's personal experience. Static tabs do not currently support the 'teams' scope. */
    staticTabs!: StaticTabs[];
    /** The set of bots for this app. Currently only one bot per app is supported. */
    bots!: Bots[];
    /** The set of Office365 connectors for this app. Currently only one connector per app is supported. */
    connectors!: Connectors[];
    /** Subscription offer associated with this app. */
    subscriptionOffer!: SubscriptionOffer;
    /** The set of compose extensions for this app. Currently only one compose extension per app is supported. */
    composeExtensions!: ComposeExtensions[];
    /** Specifies the permissions the app requests from users. */
    permissions!: Permissions[];
    /** Specify the native features on a user's device that your app may request access to. */
    devicePermissions!: DevicePermissions[];
    /** A list of valid domains from which the tabs expect to load any content. Domain listings can include wildcards, for example `*.example.com`. If your tab configuration or content UI needs to navigate to any other domain besides the one use for tab configuration, that domain must be specified here. */
    validDomains!: string[];
    /** Specify your AAD App ID and Graph information to help users seamlessly sign into your AAD app. */
    webApplicationInfo!: WebApplicationInfo;
    /** Specify the app's Graph connector configuration. If this is present then webApplicationInfo.id must also be specified. */
    graphConnector!: GraphConnector;
    /** A value indicating whether or not show loading indicator when app/tab is loading */
    showLoadingIndicator!: boolean;
    /** A value indicating whether a personal app is rendered without a tab header-bar */
    isFullScreen!: boolean;
    activities!: Activities;
    /** A list of tenant configured properties for an app */
    configurableProperties!: ConfigurableProperties[];
    /** List of 'non-standard' channel types that the app supports. Note: Channels of standard type are supported by default if the app supports team scope. */
    supportedChannelTypes!: SupportedChannelTypes[];
    /** A value indicating whether an app is blocked by default until admin allows it */
    defaultBlockUntilAdminAction!: boolean;
    /** The url to the page that provides additional app information for the admins */
    publisherDocsUrl!: string;
    /** The install scope defined for this app by default. This will be the option displayed on the button when a user tries to add the app */
    defaultInstallScope!: MosManifestDefaultInstallScope;
    /** When a group install scope is selected, this will define the default capability when the user installs the app */
    defaultGroupCapability!: DefaultGroupCapability;
    /** Specify meeting extension definition. */
    meetingExtensionDefinition!: MeetingExtensionDefinition;
    /** Specify and consolidates authorization related information for the App. */
    authorization!: Authorization;
    extensions!: Extensions[];
    /** Defines the list of cards which could be pinned to dashboards that can provide summarized view of information relevant to user. */
    dashboardCards!: DashboardCard[];

    constructor(data?: IMosManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.developer = new Developer();
            this.name = new Name();
            this.description = new Description();
            this.icons = new Icons();
            this.showLoadingIndicator = false;
            this.isFullScreen = false;
            this.defaultBlockUntilAdminAction = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.$schema = _data["$schema"];
            this.manifestVersion = _data["manifestVersion"];
            this.version = _data["version"];
            this.id = _data["id"];
            this.localizationInfo = _data["localizationInfo"] ? LocalizationInfo.fromJS(_data["localizationInfo"]) : <any>undefined;
            this.developer = _data["developer"] ? Developer.fromJS(_data["developer"]) : new Developer();
            this.name = _data["name"] ? Name.fromJS(_data["name"]) : new Name();
            this.description = _data["description"] ? Description.fromJS(_data["description"]) : new Description();
            this.icons = _data["icons"] ? Icons.fromJS(_data["icons"]) : new Icons();
            this.accentColor = _data["accentColor"];
            if (Array.isArray(_data["configurableTabs"])) {
                this.configurableTabs = [] as any;
                for (let item of _data["configurableTabs"])
                    this.configurableTabs!.push(ConfigurableTabs.fromJS(item));
            }
            if (Array.isArray(_data["staticTabs"])) {
                this.staticTabs = [] as any;
                for (let item of _data["staticTabs"])
                    this.staticTabs!.push(StaticTabs.fromJS(item));
            }
            if (Array.isArray(_data["bots"])) {
                this.bots = [] as any;
                for (let item of _data["bots"])
                    this.bots!.push(Bots.fromJS(item));
            }
            if (Array.isArray(_data["connectors"])) {
                this.connectors = [] as any;
                for (let item of _data["connectors"])
                    this.connectors!.push(Connectors.fromJS(item));
            }
            this.subscriptionOffer = _data["subscriptionOffer"] ? SubscriptionOffer.fromJS(_data["subscriptionOffer"]) : <any>undefined;
            if (Array.isArray(_data["composeExtensions"])) {
                this.composeExtensions = [] as any;
                for (let item of _data["composeExtensions"])
                    this.composeExtensions!.push(ComposeExtensions.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            if (Array.isArray(_data["devicePermissions"])) {
                this.devicePermissions = [] as any;
                for (let item of _data["devicePermissions"])
                    this.devicePermissions!.push(item);
            }
            if (Array.isArray(_data["validDomains"])) {
                this.validDomains = [] as any;
                for (let item of _data["validDomains"])
                    this.validDomains!.push(item);
            }
            this.webApplicationInfo = _data["webApplicationInfo"] ? WebApplicationInfo.fromJS(_data["webApplicationInfo"]) : <any>undefined;
            this.graphConnector = _data["graphConnector"] ? GraphConnector.fromJS(_data["graphConnector"]) : <any>undefined;
            this.showLoadingIndicator = _data["showLoadingIndicator"] !== undefined ? _data["showLoadingIndicator"] : false;
            this.isFullScreen = _data["isFullScreen"] !== undefined ? _data["isFullScreen"] : false;
            this.activities = _data["activities"] ? Activities.fromJS(_data["activities"]) : <any>undefined;
            if (Array.isArray(_data["configurableProperties"])) {
                this.configurableProperties = [] as any;
                for (let item of _data["configurableProperties"])
                    this.configurableProperties!.push(item);
            }
            if (Array.isArray(_data["supportedChannelTypes"])) {
                this.supportedChannelTypes = [] as any;
                for (let item of _data["supportedChannelTypes"])
                    this.supportedChannelTypes!.push(item);
            }
            this.defaultBlockUntilAdminAction = _data["defaultBlockUntilAdminAction"] !== undefined ? _data["defaultBlockUntilAdminAction"] : false;
            this.publisherDocsUrl = _data["publisherDocsUrl"];
            this.defaultInstallScope = _data["defaultInstallScope"];
            this.defaultGroupCapability = _data["defaultGroupCapability"] ? DefaultGroupCapability.fromJS(_data["defaultGroupCapability"]) : <any>undefined;
            this.meetingExtensionDefinition = _data["meetingExtensionDefinition"] ? MeetingExtensionDefinition.fromJS(_data["meetingExtensionDefinition"]) : <any>undefined;
            this.authorization = _data["authorization"] ? Authorization.fromJS(_data["authorization"]) : <any>undefined;
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(Extensions.fromJS(item));
            }
            if (Array.isArray(_data["dashboardCards"])) {
                this.dashboardCards = [] as any;
                for (let item of _data["dashboardCards"])
                    this.dashboardCards!.push(DashboardCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MosManifest {
        data = typeof data === 'object' ? data : {};
        let result = new MosManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$schema"] = this.$schema;
        data["manifestVersion"] = this.manifestVersion;
        data["version"] = this.version;
        data["id"] = this.id;
        data["localizationInfo"] = this.localizationInfo ? this.localizationInfo.toJSON() : <any>undefined;
        data["developer"] = this.developer ? this.developer.toJSON() : <any>undefined;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["icons"] = this.icons ? this.icons.toJSON() : <any>undefined;
        data["accentColor"] = this.accentColor;
        if (Array.isArray(this.configurableTabs)) {
            data["configurableTabs"] = [];
            for (let item of this.configurableTabs)
                data["configurableTabs"].push(item.toJSON());
        }
        if (Array.isArray(this.staticTabs)) {
            data["staticTabs"] = [];
            for (let item of this.staticTabs)
                data["staticTabs"].push(item.toJSON());
        }
        if (Array.isArray(this.bots)) {
            data["bots"] = [];
            for (let item of this.bots)
                data["bots"].push(item.toJSON());
        }
        if (Array.isArray(this.connectors)) {
            data["connectors"] = [];
            for (let item of this.connectors)
                data["connectors"].push(item.toJSON());
        }
        data["subscriptionOffer"] = this.subscriptionOffer ? this.subscriptionOffer.toJSON() : <any>undefined;
        if (Array.isArray(this.composeExtensions)) {
            data["composeExtensions"] = [];
            for (let item of this.composeExtensions)
                data["composeExtensions"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        if (Array.isArray(this.devicePermissions)) {
            data["devicePermissions"] = [];
            for (let item of this.devicePermissions)
                data["devicePermissions"].push(item);
        }
        if (Array.isArray(this.validDomains)) {
            data["validDomains"] = [];
            for (let item of this.validDomains)
                data["validDomains"].push(item);
        }
        data["webApplicationInfo"] = this.webApplicationInfo ? this.webApplicationInfo.toJSON() : <any>undefined;
        data["graphConnector"] = this.graphConnector ? this.graphConnector.toJSON() : <any>undefined;
        data["showLoadingIndicator"] = this.showLoadingIndicator;
        data["isFullScreen"] = this.isFullScreen;
        data["activities"] = this.activities ? this.activities.toJSON() : <any>undefined;
        if (Array.isArray(this.configurableProperties)) {
            data["configurableProperties"] = [];
            for (let item of this.configurableProperties)
                data["configurableProperties"].push(item);
        }
        if (Array.isArray(this.supportedChannelTypes)) {
            data["supportedChannelTypes"] = [];
            for (let item of this.supportedChannelTypes)
                data["supportedChannelTypes"].push(item);
        }
        data["defaultBlockUntilAdminAction"] = this.defaultBlockUntilAdminAction;
        data["publisherDocsUrl"] = this.publisherDocsUrl;
        data["defaultInstallScope"] = this.defaultInstallScope;
        data["defaultGroupCapability"] = this.defaultGroupCapability ? this.defaultGroupCapability.toJSON() : <any>undefined;
        data["meetingExtensionDefinition"] = this.meetingExtensionDefinition ? this.meetingExtensionDefinition.toJSON() : <any>undefined;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : <any>undefined;
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item.toJSON());
        }
        if (Array.isArray(this.dashboardCards)) {
            data["dashboardCards"] = [];
            for (let item of this.dashboardCards)
                data["dashboardCards"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMosManifest {
    $schema: string;
    /** The version of the schema this manifest is using. This schema version supports extending Teams apps to other parts of the Microsoft 365 ecosystem. More info at https://aka.ms/extendteamsapps. */
    manifestVersion: string;
    /** The version of the app. Changes to your manifest should cause a version change. This version string must follow the semver standard (http://semver.org). */
    version: string;
    /** A unique identifier for this app. This id must be a GUID. */
    id: string;
    localizationInfo: LocalizationInfo;
    developer: Developer;
    name: Name;
    description: Description;
    icons: Icons;
    /** A color to use in conjunction with the icon. The value must be a valid HTML color code starting with '#', for example `#4464ee`. */
    accentColor: string;
    /** These are tabs users can optionally add to their channels and 1:1 or group chats and require extra configuration before they are added. Configurable tabs are not supported in the personal scope. Currently only one configurable tab per app is supported. */
    configurableTabs: ConfigurableTabs[];
    /** A set of tabs that may be 'pinned' by default, without the user adding them manually. Static tabs declared in personal scope are always pinned to the app's personal experience. Static tabs do not currently support the 'teams' scope. */
    staticTabs: StaticTabs[];
    /** The set of bots for this app. Currently only one bot per app is supported. */
    bots: Bots[];
    /** The set of Office365 connectors for this app. Currently only one connector per app is supported. */
    connectors: Connectors[];
    /** Subscription offer associated with this app. */
    subscriptionOffer: SubscriptionOffer;
    /** The set of compose extensions for this app. Currently only one compose extension per app is supported. */
    composeExtensions: ComposeExtensions[];
    /** Specifies the permissions the app requests from users. */
    permissions: Permissions[];
    /** Specify the native features on a user's device that your app may request access to. */
    devicePermissions: DevicePermissions[];
    /** A list of valid domains from which the tabs expect to load any content. Domain listings can include wildcards, for example `*.example.com`. If your tab configuration or content UI needs to navigate to any other domain besides the one use for tab configuration, that domain must be specified here. */
    validDomains: string[];
    /** Specify your AAD App ID and Graph information to help users seamlessly sign into your AAD app. */
    webApplicationInfo: WebApplicationInfo;
    /** Specify the app's Graph connector configuration. If this is present then webApplicationInfo.id must also be specified. */
    graphConnector: GraphConnector;
    /** A value indicating whether or not show loading indicator when app/tab is loading */
    showLoadingIndicator: boolean;
    /** A value indicating whether a personal app is rendered without a tab header-bar */
    isFullScreen: boolean;
    activities: Activities;
    /** A list of tenant configured properties for an app */
    configurableProperties: ConfigurableProperties[];
    /** List of 'non-standard' channel types that the app supports. Note: Channels of standard type are supported by default if the app supports team scope. */
    supportedChannelTypes: SupportedChannelTypes[];
    /** A value indicating whether an app is blocked by default until admin allows it */
    defaultBlockUntilAdminAction: boolean;
    /** The url to the page that provides additional app information for the admins */
    publisherDocsUrl: string;
    /** The install scope defined for this app by default. This will be the option displayed on the button when a user tries to add the app */
    defaultInstallScope: MosManifestDefaultInstallScope;
    /** When a group install scope is selected, this will define the default capability when the user installs the app */
    defaultGroupCapability: DefaultGroupCapability;
    /** Specify meeting extension definition. */
    meetingExtensionDefinition: MeetingExtensionDefinition;
    /** Specify and consolidates authorization related information for the App. */
    authorization: Authorization;
    extensions: Extensions[];
    /** Defines the list of cards which could be pinned to dashboards that can provide summarized view of information relevant to user. */
    dashboardCards: DashboardCard[];
}

export class Capabilities implements ICapabilities {
    /** Identifies the name of the requirement sets that the add-in needs to run. */
    name!: string;
    /** Identifies the minimum version for the requirement sets that the add-in needs to run. */
    minVersion!: string;
    /** Identifies the maximum version for the requirement sets that the add-in needs to run. */
    maxVersion!: string;

    constructor(data?: ICapabilities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.minVersion = _data["minVersion"];
            this.maxVersion = _data["maxVersion"];
        }
    }

    static fromJS(data: any): Capabilities {
        data = typeof data === 'object' ? data : {};
        let result = new Capabilities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["minVersion"] = this.minVersion;
        data["maxVersion"] = this.maxVersion;
        return data;
    }
}

export interface ICapabilities {
    /** Identifies the name of the requirement sets that the add-in needs to run. */
    name: string;
    /** Identifies the minimum version for the requirement sets that the add-in needs to run. */
    minVersion: string;
    /** Identifies the maximum version for the requirement sets that the add-in needs to run. */
    maxVersion: string;
}

export enum Scopes {
    Mail = "mail",
    Workbook = "workbook",
    Document = "document",
    Presentation = "presentation",
}

export enum FormFactors {
    Desktop = "desktop",
    Mobile = "mobile",
}

export enum ExtensionRuntimesActionsItemType {
    ExecuteFunction = "executeFunction",
    OpenPage = "openPage",
}

export class Position implements IPosition {
    /** The id of the built-in tab. Maximum length is 64 characters. */
    builtInTabId!: string;
    /** Define alignment of this custom tab relative to the specified built-in tab. */
    align!: PositionAlign;

    constructor(data?: IPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.builtInTabId = _data["builtInTabId"];
            this.align = _data["align"];
        }
    }

    static fromJS(data: any): Position {
        data = typeof data === 'object' ? data : {};
        let result = new Position();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["builtInTabId"] = this.builtInTabId;
        data["align"] = this.align;
        return data;
    }
}

export interface IPosition {
    /** The id of the built-in tab. Maximum length is 64 characters. */
    builtInTabId: string;
    /** Define alignment of this custom tab relative to the specified built-in tab. */
    align: PositionAlign;
}

export enum ExtensionCommonCustomGroupControlsItemType {
    Button = "button",
    Menu = "menu",
}

export enum ExtensionCommonCustomControlMenuType {
    Menu = "menu",
}

export enum ExtensionCommonCustomControlMenuItemType {
    MenuItem = "menuItem",
}

export enum ExtensionRibbonsCustomMobileControlButtonItemType {
    MobileButton = "mobileButton",
}

export enum DashboardCardDefaultSize {
    Medium = "medium",
    Large = "large",
}

export enum DashboardCardContentSourceSourceType {
    Bot = "bot",
}

export class BotConfiguration implements IBotConfiguration {
    /** The unique Microsoft app ID for the bot as registered with the Bot Framework. */
    botId!: string;

    constructor(data?: IBotConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.botId = _data["botId"];
        }
    }

    static fromJS(data: any): BotConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new BotConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["botId"] = this.botId;
        return data;
    }
}

export interface IBotConfiguration {
    /** The unique Microsoft app ID for the bot as registered with the Bot Framework. */
    botId: string;
}

export class LocalizationInfo implements ILocalizationInfo {
    /** The language tag of the strings in this top level manifest file. */
    defaultLanguageTag!: string;
    additionalLanguages!: AdditionalLanguages[];

    constructor(data?: ILocalizationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageTag = _data["defaultLanguageTag"];
            if (Array.isArray(_data["additionalLanguages"])) {
                this.additionalLanguages = [] as any;
                for (let item of _data["additionalLanguages"])
                    this.additionalLanguages!.push(AdditionalLanguages.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageTag"] = this.defaultLanguageTag;
        if (Array.isArray(this.additionalLanguages)) {
            data["additionalLanguages"] = [];
            for (let item of this.additionalLanguages)
                data["additionalLanguages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizationInfo {
    /** The language tag of the strings in this top level manifest file. */
    defaultLanguageTag: string;
    additionalLanguages: AdditionalLanguages[];
}

export class Developer implements IDeveloper {
    /** The display name for the developer. */
    name!: string;
    /** The Microsoft Partner Network ID that identifies the partner organization building the app. This field is not required, and should only be used if you are already part of the Microsoft Partner Network. More info at https://aka.ms/partner */
    mpnId!: string;
    /** The url to the page that provides support information for the app. */
    websiteUrl!: string;
    /** The url to the page that provides privacy information for the app. */
    privacyUrl!: string;
    /** The url to the page that provides the terms of use for the app. */
    termsOfUseUrl!: string;

    constructor(data?: IDeveloper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.mpnId = _data["mpnId"];
            this.websiteUrl = _data["websiteUrl"];
            this.privacyUrl = _data["privacyUrl"];
            this.termsOfUseUrl = _data["termsOfUseUrl"];
        }
    }

    static fromJS(data: any): Developer {
        data = typeof data === 'object' ? data : {};
        let result = new Developer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["mpnId"] = this.mpnId;
        data["websiteUrl"] = this.websiteUrl;
        data["privacyUrl"] = this.privacyUrl;
        data["termsOfUseUrl"] = this.termsOfUseUrl;
        return data;
    }
}

export interface IDeveloper {
    /** The display name for the developer. */
    name: string;
    /** The Microsoft Partner Network ID that identifies the partner organization building the app. This field is not required, and should only be used if you are already part of the Microsoft Partner Network. More info at https://aka.ms/partner */
    mpnId: string;
    /** The url to the page that provides support information for the app. */
    websiteUrl: string;
    /** The url to the page that provides privacy information for the app. */
    privacyUrl: string;
    /** The url to the page that provides the terms of use for the app. */
    termsOfUseUrl: string;
}

export class Name implements IName {
    /** A short display name for the app. */
    short!: string;
    /** The full name of the app, used if the full app name exceeds 30 characters. */
    full!: string;

    constructor(data?: IName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.short = _data["short"];
            this.full = _data["full"];
        }
    }

    static fromJS(data: any): Name {
        data = typeof data === 'object' ? data : {};
        let result = new Name();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["short"] = this.short;
        data["full"] = this.full;
        return data;
    }
}

export interface IName {
    /** A short display name for the app. */
    short: string;
    /** The full name of the app, used if the full app name exceeds 30 characters. */
    full: string;
}

export class Description implements IDescription {
    /** A short description of the app used when space is limited. Maximum length is 80 characters. */
    short!: string;
    /** The full description of the app. Maximum length is 4000 characters. */
    full!: string;

    constructor(data?: IDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.short = _data["short"];
            this.full = _data["full"];
        }
    }

    static fromJS(data: any): Description {
        data = typeof data === 'object' ? data : {};
        let result = new Description();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["short"] = this.short;
        data["full"] = this.full;
        return data;
    }
}

export interface IDescription {
    /** A short description of the app used when space is limited. Maximum length is 80 characters. */
    short: string;
    /** The full description of the app. Maximum length is 4000 characters. */
    full: string;
}

export class Icons implements IIcons {
    /** A relative file path to a transparent PNG outline icon. The border color needs to be white. Size 32x32. */
    outline!: string;
    /** A relative file path to a full color PNG icon. Size 192x192. */
    color!: string;

    constructor(data?: IIcons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outline = _data["outline"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): Icons {
        data = typeof data === 'object' ? data : {};
        let result = new Icons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outline"] = this.outline;
        data["color"] = this.color;
        return data;
    }
}

export interface IIcons {
    /** A relative file path to a transparent PNG outline icon. The border color needs to be white. Size 32x32. */
    outline: string;
    /** A relative file path to a full color PNG icon. Size 192x192. */
    color: string;
}

export class ConfigurableTabs implements IConfigurableTabs {
    /** The url to use when configuring the tab. */
    configurationUrl!: string;
    /** A value indicating whether an instance of the tab's configuration can be updated by the user after creation. */
    canUpdateConfiguration!: boolean;
    /** Specifies whether the tab offers an experience in the context of a channel in a team, in a 1:1 or group chat, or in an experience scoped to an individual user alone. These options are non-exclusive. Currently, configurable tabs are only supported in the teams and groupchats scopes. */
    scopes!: Scopes2[];
    /** The set of meetingSurfaceItem scopes that a tab belong to */
    meetingSurfaces!: MeetingSurfaces[];
    /** The set of contextItem scopes that a tab belong to */
    context!: Context[];
    /** A relative file path to a tab preview image for use in SharePoint. Size 1024x768. */
    sharePointPreviewImage!: string;
    /** Defines how your tab will be made available in SharePoint. */
    supportedSharePointHosts!: SupportedSharePointHosts[];

    constructor(data?: IConfigurableTabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.canUpdateConfiguration = true;
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configurationUrl = _data["configurationUrl"];
            this.canUpdateConfiguration = _data["canUpdateConfiguration"] !== undefined ? _data["canUpdateConfiguration"] : true;
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            if (Array.isArray(_data["meetingSurfaces"])) {
                this.meetingSurfaces = [] as any;
                for (let item of _data["meetingSurfaces"])
                    this.meetingSurfaces!.push(item);
            }
            if (Array.isArray(_data["context"])) {
                this.context = [] as any;
                for (let item of _data["context"])
                    this.context!.push(item);
            }
            this.sharePointPreviewImage = _data["sharePointPreviewImage"];
            if (Array.isArray(_data["supportedSharePointHosts"])) {
                this.supportedSharePointHosts = [] as any;
                for (let item of _data["supportedSharePointHosts"])
                    this.supportedSharePointHosts!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigurableTabs {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurableTabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configurationUrl"] = this.configurationUrl;
        data["canUpdateConfiguration"] = this.canUpdateConfiguration;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        if (Array.isArray(this.meetingSurfaces)) {
            data["meetingSurfaces"] = [];
            for (let item of this.meetingSurfaces)
                data["meetingSurfaces"].push(item);
        }
        if (Array.isArray(this.context)) {
            data["context"] = [];
            for (let item of this.context)
                data["context"].push(item);
        }
        data["sharePointPreviewImage"] = this.sharePointPreviewImage;
        if (Array.isArray(this.supportedSharePointHosts)) {
            data["supportedSharePointHosts"] = [];
            for (let item of this.supportedSharePointHosts)
                data["supportedSharePointHosts"].push(item);
        }
        return data;
    }
}

export interface IConfigurableTabs {
    /** The url to use when configuring the tab. */
    configurationUrl: string;
    /** A value indicating whether an instance of the tab's configuration can be updated by the user after creation. */
    canUpdateConfiguration: boolean;
    /** Specifies whether the tab offers an experience in the context of a channel in a team, in a 1:1 or group chat, or in an experience scoped to an individual user alone. These options are non-exclusive. Currently, configurable tabs are only supported in the teams and groupchats scopes. */
    scopes: Scopes2[];
    /** The set of meetingSurfaceItem scopes that a tab belong to */
    meetingSurfaces: MeetingSurfaces[];
    /** The set of contextItem scopes that a tab belong to */
    context: Context[];
    /** A relative file path to a tab preview image for use in SharePoint. Size 1024x768. */
    sharePointPreviewImage: string;
    /** Defines how your tab will be made available in SharePoint. */
    supportedSharePointHosts: SupportedSharePointHosts[];
}

export class StaticTabs implements IStaticTabs {
    /** A unique identifier for the entity which the tab displays. */
    entityId!: string;
    /** The display name of the tab. */
    name!: string;
    /** The url which points to the entity UI to be displayed in the canvas. */
    contentUrl!: string;
    /** The Microsoft App ID specified for the bot in the Bot Framework portal (https://dev.botframework.com/bots) */
    contentBotId!: string;
    /** The url to point at if a user opts to view in a browser. */
    websiteUrl!: string;
    /** The url to direct a user's search queries. */
    searchUrl!: string;
    /** Specifies whether the tab offers an experience in the context of a channel in a team, or an experience scoped to an individual user alone or group chat. These options are non-exclusive. Currently static tabs are only supported in the 'personal' scope. */
    scopes!: Scopes3[];
    /** The set of contextItem scopes that a tab belong to */
    context!: Context2[];

    constructor(data?: IStaticTabs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.name = _data["name"];
            this.contentUrl = _data["contentUrl"];
            this.contentBotId = _data["contentBotId"];
            this.websiteUrl = _data["websiteUrl"];
            this.searchUrl = _data["searchUrl"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            if (Array.isArray(_data["context"])) {
                this.context = [] as any;
                for (let item of _data["context"])
                    this.context!.push(item);
            }
        }
    }

    static fromJS(data: any): StaticTabs {
        data = typeof data === 'object' ? data : {};
        let result = new StaticTabs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        data["contentUrl"] = this.contentUrl;
        data["contentBotId"] = this.contentBotId;
        data["websiteUrl"] = this.websiteUrl;
        data["searchUrl"] = this.searchUrl;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        if (Array.isArray(this.context)) {
            data["context"] = [];
            for (let item of this.context)
                data["context"].push(item);
        }
        return data;
    }
}

export interface IStaticTabs {
    /** A unique identifier for the entity which the tab displays. */
    entityId: string;
    /** The display name of the tab. */
    name: string;
    /** The url which points to the entity UI to be displayed in the canvas. */
    contentUrl: string;
    /** The Microsoft App ID specified for the bot in the Bot Framework portal (https://dev.botframework.com/bots) */
    contentBotId: string;
    /** The url to point at if a user opts to view in a browser. */
    websiteUrl: string;
    /** The url to direct a user's search queries. */
    searchUrl: string;
    /** Specifies whether the tab offers an experience in the context of a channel in a team, or an experience scoped to an individual user alone or group chat. These options are non-exclusive. Currently static tabs are only supported in the 'personal' scope. */
    scopes: Scopes3[];
    /** The set of contextItem scopes that a tab belong to */
    context: Context2[];
}

export class Bots implements IBots {
    /** The Microsoft App ID specified for the bot in the Bot Framework portal (https://dev.botframework.com/bots) */
    botId!: string;
    configuration!: Configuration;
    /** This value describes whether or not the bot utilizes a user hint to add the bot to a specific channel. */
    needsChannelSelector!: boolean;
    /** A value indicating whether or not the bot is a one-way notification only bot, as opposed to a conversational bot. */
    isNotificationOnly!: boolean;
    /** A value indicating whether the bot supports uploading/downloading of files. */
    supportsFiles!: boolean;
    /** A value indicating whether the bot supports audio calling. */
    supportsCalling!: boolean;
    /** A value indicating whether the bot supports video calling. */
    supportsVideo!: boolean;
    /** Specifies whether the bot offers an experience in the context of a channel in a team, in a 1:1 or group chat, or in an experience scoped to an individual user alone. These options are non-exclusive. */
    scopes!: Scopes4[];
    /** The list of commands that the bot supplies, including their usage, description, and the scope for which the commands are valid. A separate command list should be used for each scope. */
    commandLists!: CommandLists[];

    constructor(data?: IBots) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.needsChannelSelector = false;
            this.isNotificationOnly = false;
            this.supportsFiles = false;
            this.supportsCalling = false;
            this.supportsVideo = false;
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.botId = _data["botId"];
            this.configuration = _data["configuration"] ? Configuration.fromJS(_data["configuration"]) : <any>undefined;
            this.needsChannelSelector = _data["needsChannelSelector"] !== undefined ? _data["needsChannelSelector"] : false;
            this.isNotificationOnly = _data["isNotificationOnly"] !== undefined ? _data["isNotificationOnly"] : false;
            this.supportsFiles = _data["supportsFiles"] !== undefined ? _data["supportsFiles"] : false;
            this.supportsCalling = _data["supportsCalling"] !== undefined ? _data["supportsCalling"] : false;
            this.supportsVideo = _data["supportsVideo"] !== undefined ? _data["supportsVideo"] : false;
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            if (Array.isArray(_data["commandLists"])) {
                this.commandLists = [] as any;
                for (let item of _data["commandLists"])
                    this.commandLists!.push(CommandLists.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Bots {
        data = typeof data === 'object' ? data : {};
        let result = new Bots();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["botId"] = this.botId;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        data["needsChannelSelector"] = this.needsChannelSelector;
        data["isNotificationOnly"] = this.isNotificationOnly;
        data["supportsFiles"] = this.supportsFiles;
        data["supportsCalling"] = this.supportsCalling;
        data["supportsVideo"] = this.supportsVideo;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        if (Array.isArray(this.commandLists)) {
            data["commandLists"] = [];
            for (let item of this.commandLists)
                data["commandLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBots {
    /** The Microsoft App ID specified for the bot in the Bot Framework portal (https://dev.botframework.com/bots) */
    botId: string;
    configuration: Configuration;
    /** This value describes whether or not the bot utilizes a user hint to add the bot to a specific channel. */
    needsChannelSelector: boolean;
    /** A value indicating whether or not the bot is a one-way notification only bot, as opposed to a conversational bot. */
    isNotificationOnly: boolean;
    /** A value indicating whether the bot supports uploading/downloading of files. */
    supportsFiles: boolean;
    /** A value indicating whether the bot supports audio calling. */
    supportsCalling: boolean;
    /** A value indicating whether the bot supports video calling. */
    supportsVideo: boolean;
    /** Specifies whether the bot offers an experience in the context of a channel in a team, in a 1:1 or group chat, or in an experience scoped to an individual user alone. These options are non-exclusive. */
    scopes: Scopes4[];
    /** The list of commands that the bot supplies, including their usage, description, and the scope for which the commands are valid. A separate command list should be used for each scope. */
    commandLists: CommandLists[];
}

export class Connectors implements IConnectors {
    /** A unique identifier for the connector which matches its ID in the Connectors Developer Portal. */
    connectorId!: string;
    /** The url to use for configuring the connector using the inline configuration experience. */
    configurationUrl!: string;
    /** Specifies whether the connector offers an experience in the context of a channel in a team, or an experience scoped to an individual user alone. Currently, only the team scope is supported. */
    scopes!: Scopes5[];

    constructor(data?: IConnectors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectorId = _data["connectorId"];
            this.configurationUrl = _data["configurationUrl"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static fromJS(data: any): Connectors {
        data = typeof data === 'object' ? data : {};
        let result = new Connectors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectorId"] = this.connectorId;
        data["configurationUrl"] = this.configurationUrl;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}

export interface IConnectors {
    /** A unique identifier for the connector which matches its ID in the Connectors Developer Portal. */
    connectorId: string;
    /** The url to use for configuring the connector using the inline configuration experience. */
    configurationUrl: string;
    /** Specifies whether the connector offers an experience in the context of a channel in a team, or an experience scoped to an individual user alone. Currently, only the team scope is supported. */
    scopes: Scopes5[];
}

export class SubscriptionOffer implements ISubscriptionOffer {
    /** A unique identifier for the Commercial Marketplace Software as a Service Offer. */
    offerId!: string;

    constructor(data?: ISubscriptionOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["offerId"];
        }
    }

    static fromJS(data: any): SubscriptionOffer {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionOffer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerId"] = this.offerId;
        return data;
    }
}

export interface ISubscriptionOffer {
    /** A unique identifier for the Commercial Marketplace Software as a Service Offer. */
    offerId: string;
}

export class ComposeExtensions implements IComposeExtensions {
    /** The Microsoft App ID specified for the bot powering the compose extension in the Bot Framework portal (https://dev.botframework.com/bots) */
    botId!: string;
    /** Type of the compose extension. */
    composeExtensionType!: ComposeExtensionsComposeExtensionType;
    /** Object capturing authorization information. */
    authorization!: Authorization2;
    /** A relative file path to the api specification file in the manifest package. */
    apiSpecificationFile!: string;
    /** A value indicating whether the configuration of a compose extension can be updated by the user. */
    canUpdateConfiguration!: boolean | undefined;
    commands!: Commands[];
    /** A list of handlers that allow apps to be invoked when certain conditions are met */
    messageHandlers!: MessageHandlers[];

    constructor(data?: IComposeExtensions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.canUpdateConfiguration = null;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.botId = _data["botId"];
            this.composeExtensionType = _data["composeExtensionType"];
            this.authorization = _data["authorization"] ? Authorization2.fromJS(_data["authorization"]) : <any>undefined;
            this.apiSpecificationFile = _data["apiSpecificationFile"];
            this.canUpdateConfiguration = _data["canUpdateConfiguration"] !== undefined ? _data["canUpdateConfiguration"] : null;
            if (Array.isArray(_data["commands"])) {
                this.commands = [] as any;
                for (let item of _data["commands"])
                    this.commands!.push(Commands.fromJS(item));
            }
            if (Array.isArray(_data["messageHandlers"])) {
                this.messageHandlers = [] as any;
                for (let item of _data["messageHandlers"])
                    this.messageHandlers!.push(MessageHandlers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComposeExtensions {
        data = typeof data === 'object' ? data : {};
        let result = new ComposeExtensions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["botId"] = this.botId;
        data["composeExtensionType"] = this.composeExtensionType;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : <any>undefined;
        data["apiSpecificationFile"] = this.apiSpecificationFile;
        data["canUpdateConfiguration"] = this.canUpdateConfiguration;
        if (Array.isArray(this.commands)) {
            data["commands"] = [];
            for (let item of this.commands)
                data["commands"].push(item.toJSON());
        }
        if (Array.isArray(this.messageHandlers)) {
            data["messageHandlers"] = [];
            for (let item of this.messageHandlers)
                data["messageHandlers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComposeExtensions {
    /** The Microsoft App ID specified for the bot powering the compose extension in the Bot Framework portal (https://dev.botframework.com/bots) */
    botId: string;
    /** Type of the compose extension. */
    composeExtensionType: ComposeExtensionsComposeExtensionType;
    /** Object capturing authorization information. */
    authorization: Authorization2;
    /** A relative file path to the api specification file in the manifest package. */
    apiSpecificationFile: string;
    /** A value indicating whether the configuration of a compose extension can be updated by the user. */
    canUpdateConfiguration: boolean | undefined;
    commands: Commands[];
    /** A list of handlers that allow apps to be invoked when certain conditions are met */
    messageHandlers: MessageHandlers[];
}

export enum Permissions {
    Identity = "identity",
    MessageTeamMembers = "messageTeamMembers",
}

export enum DevicePermissions {
    Geolocation = "geolocation",
    Media = "media",
    Notifications = "notifications",
    Midi = "midi",
    OpenExternal = "openExternal",
}

export class WebApplicationInfo implements IWebApplicationInfo {
    /** AAD application id of the app. This id must be a GUID. */
    id!: string;
    /** Resource url of app for acquiring auth token for SSO. */
    resource!: string;

    constructor(data?: IWebApplicationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): WebApplicationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WebApplicationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resource"] = this.resource;
        return data;
    }
}

export interface IWebApplicationInfo {
    /** AAD application id of the app. This id must be a GUID. */
    id: string;
    /** Resource url of app for acquiring auth token for SSO. */
    resource: string;
}

export class GraphConnector implements IGraphConnector {
    /** The url where Graph-connector notifications for the application should be sent. */
    notificationUrl!: string;

    constructor(data?: IGraphConnector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationUrl = _data["notificationUrl"];
        }
    }

    static fromJS(data: any): GraphConnector {
        data = typeof data === 'object' ? data : {};
        let result = new GraphConnector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationUrl"] = this.notificationUrl;
        return data;
    }
}

export interface IGraphConnector {
    /** The url where Graph-connector notifications for the application should be sent. */
    notificationUrl: string;
}

export class Activities implements IActivities {
    /** Specify the types of activites that your app can post to a users activity feed */
    activityTypes!: ActivityTypes[];

    constructor(data?: IActivities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityTypes"])) {
                this.activityTypes = [] as any;
                for (let item of _data["activityTypes"])
                    this.activityTypes!.push(ActivityTypes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Activities {
        data = typeof data === 'object' ? data : {};
        let result = new Activities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityTypes)) {
            data["activityTypes"] = [];
            for (let item of this.activityTypes)
                data["activityTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivities {
    /** Specify the types of activites that your app can post to a users activity feed */
    activityTypes: ActivityTypes[];
}

export enum ConfigurableProperties {
    Name = "name",
    ShortDescription = "shortDescription",
    LongDescription = "longDescription",
    SmallImageUrl = "smallImageUrl",
    LargeImageUrl = "largeImageUrl",
    AccentColor = "accentColor",
    DeveloperUrl = "developerUrl",
    PrivacyUrl = "privacyUrl",
    TermsOfUseUrl = "termsOfUseUrl",
}

export enum SupportedChannelTypes {
    SharedChannels = "sharedChannels",
    PrivateChannels = "privateChannels",
}

export enum MosManifestDefaultInstallScope {
    Personal = "personal",
    Team = "team",
    GroupChat = "groupChat",
    Meetings = "meetings",
}

export class DefaultGroupCapability implements IDefaultGroupCapability {
    /** When the install scope selected is Team, this field specifies the default capability available */
    team!: DefaultGroupCapabilityTeam;
    /** When the install scope selected is GroupChat, this field specifies the default capability available */
    groupchat!: DefaultGroupCapabilityGroupchat;
    /** When the install scope selected is Meetings, this field specifies the default capability available */
    meetings!: DefaultGroupCapabilityMeetings;

    constructor(data?: IDefaultGroupCapability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"];
            this.groupchat = _data["groupchat"];
            this.meetings = _data["meetings"];
        }
    }

    static fromJS(data: any): DefaultGroupCapability {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultGroupCapability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team;
        data["groupchat"] = this.groupchat;
        data["meetings"] = this.meetings;
        return data;
    }
}

export interface IDefaultGroupCapability {
    /** When the install scope selected is Team, this field specifies the default capability available */
    team: DefaultGroupCapabilityTeam;
    /** When the install scope selected is GroupChat, this field specifies the default capability available */
    groupchat: DefaultGroupCapabilityGroupchat;
    /** When the install scope selected is Meetings, this field specifies the default capability available */
    meetings: DefaultGroupCapabilityMeetings;
}

export class MeetingExtensionDefinition implements IMeetingExtensionDefinition {
    /** Meeting supported scenes. */
    scenes!: Scenes[];
    /** A boolean value indicating whether this app can stream the meeting's audio video content to an RTMP endpoint. */
    supportsStreaming!: boolean;
    /** A boolean value indicating whether this app allows management by anonymous users. */
    supportsAnonymousGuestUsers!: boolean;

    constructor(data?: IMeetingExtensionDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.supportsStreaming = false;
            this.supportsAnonymousGuestUsers = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scenes"])) {
                this.scenes = [] as any;
                for (let item of _data["scenes"])
                    this.scenes!.push(Scenes.fromJS(item));
            }
            this.supportsStreaming = _data["supportsStreaming"] !== undefined ? _data["supportsStreaming"] : false;
            this.supportsAnonymousGuestUsers = _data["supportsAnonymousGuestUsers"] !== undefined ? _data["supportsAnonymousGuestUsers"] : false;
        }
    }

    static fromJS(data: any): MeetingExtensionDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingExtensionDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scenes)) {
            data["scenes"] = [];
            for (let item of this.scenes)
                data["scenes"].push(item.toJSON());
        }
        data["supportsStreaming"] = this.supportsStreaming;
        data["supportsAnonymousGuestUsers"] = this.supportsAnonymousGuestUsers;
        return data;
    }
}

export interface IMeetingExtensionDefinition {
    /** Meeting supported scenes. */
    scenes: Scenes[];
    /** A boolean value indicating whether this app can stream the meeting's audio video content to an RTMP endpoint. */
    supportsStreaming: boolean;
    /** A boolean value indicating whether this app allows management by anonymous users. */
    supportsAnonymousGuestUsers: boolean;
}

export class Authorization implements IAuthorization {
    /** List of permissions that the app needs to function. */
    permissions!: Permissions2;

    constructor(data?: IAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissions = _data["permissions"] ? Permissions2.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Authorization {
        data = typeof data === 'object' ? data : {};
        let result = new Authorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthorization {
    /** List of permissions that the app needs to function. */
    permissions: Permissions2;
}

export class Extensions implements IExtensions {
    requirements!: RequirementsExtensionElement;
    runtimes!: Runtimes[];
    ribbons!: Ribbons[];
    autoRunEvents!: AutoRunEvents[];
    alternates!: Alternates[];
    /** The url for your extension, used to validate Exchange user identity tokens. */
    audienceClaimUrl!: string;
    contentRuntimes!: ContentRuntimes[];
    getStartedMessages!: GetStartedMessages[];
    contextMenus!: ContextMenus[];

    constructor(data?: IExtensions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            if (Array.isArray(_data["runtimes"])) {
                this.runtimes = [] as any;
                for (let item of _data["runtimes"])
                    this.runtimes!.push(Runtimes.fromJS(item));
            }
            if (Array.isArray(_data["ribbons"])) {
                this.ribbons = [] as any;
                for (let item of _data["ribbons"])
                    this.ribbons!.push(Ribbons.fromJS(item));
            }
            if (Array.isArray(_data["autoRunEvents"])) {
                this.autoRunEvents = [] as any;
                for (let item of _data["autoRunEvents"])
                    this.autoRunEvents!.push(AutoRunEvents.fromJS(item));
            }
            if (Array.isArray(_data["alternates"])) {
                this.alternates = [] as any;
                for (let item of _data["alternates"])
                    this.alternates!.push(Alternates.fromJS(item));
            }
            this.audienceClaimUrl = _data["audienceClaimUrl"];
            if (Array.isArray(_data["contentRuntimes"])) {
                this.contentRuntimes = [] as any;
                for (let item of _data["contentRuntimes"])
                    this.contentRuntimes!.push(ContentRuntimes.fromJS(item));
            }
            if (Array.isArray(_data["getStartedMessages"])) {
                this.getStartedMessages = [] as any;
                for (let item of _data["getStartedMessages"])
                    this.getStartedMessages!.push(GetStartedMessages.fromJS(item));
            }
            if (Array.isArray(_data["contextMenus"])) {
                this.contextMenus = [] as any;
                for (let item of _data["contextMenus"])
                    this.contextMenus!.push(ContextMenus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Extensions {
        data = typeof data === 'object' ? data : {};
        let result = new Extensions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        if (Array.isArray(this.runtimes)) {
            data["runtimes"] = [];
            for (let item of this.runtimes)
                data["runtimes"].push(item.toJSON());
        }
        if (Array.isArray(this.ribbons)) {
            data["ribbons"] = [];
            for (let item of this.ribbons)
                data["ribbons"].push(item.toJSON());
        }
        if (Array.isArray(this.autoRunEvents)) {
            data["autoRunEvents"] = [];
            for (let item of this.autoRunEvents)
                data["autoRunEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.alternates)) {
            data["alternates"] = [];
            for (let item of this.alternates)
                data["alternates"].push(item.toJSON());
        }
        data["audienceClaimUrl"] = this.audienceClaimUrl;
        if (Array.isArray(this.contentRuntimes)) {
            data["contentRuntimes"] = [];
            for (let item of this.contentRuntimes)
                data["contentRuntimes"].push(item.toJSON());
        }
        if (Array.isArray(this.getStartedMessages)) {
            data["getStartedMessages"] = [];
            for (let item of this.getStartedMessages)
                data["getStartedMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.contextMenus)) {
            data["contextMenus"] = [];
            for (let item of this.contextMenus)
                data["contextMenus"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtensions {
    requirements: RequirementsExtensionElement;
    runtimes: Runtimes[];
    ribbons: Ribbons[];
    autoRunEvents: AutoRunEvents[];
    alternates: Alternates[];
    /** The url for your extension, used to validate Exchange user identity tokens. */
    audienceClaimUrl: string;
    contentRuntimes: ContentRuntimes[];
    getStartedMessages: GetStartedMessages[];
    contextMenus: ContextMenus[];
}

export enum PositionAlign {
    After = "after",
    Before = "before",
}

export class AdditionalLanguages implements IAdditionalLanguages {
    /** The language tag of the strings in the provided file. */
    languageTag!: string;
    /** A relative file path to a the .json file containing the translated strings. */
    file!: string;

    constructor(data?: IAdditionalLanguages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageTag = _data["languageTag"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): AdditionalLanguages {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalLanguages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageTag"] = this.languageTag;
        data["file"] = this.file;
        return data;
    }
}

export interface IAdditionalLanguages {
    /** The language tag of the strings in the provided file. */
    languageTag: string;
    /** A relative file path to a the .json file containing the translated strings. */
    file: string;
}

export enum Scopes2 {
    Team = "team",
    GroupChat = "groupChat",
}

export enum MeetingSurfaces {
    SidePanel = "sidePanel",
    Stage = "stage",
}

export enum Context {
    PersonalTab = "personalTab",
    ChannelTab = "channelTab",
    PrivateChatTab = "privateChatTab",
    MeetingChatTab = "meetingChatTab",
    MeetingDetailsTab = "meetingDetailsTab",
    MeetingSidePanel = "meetingSidePanel",
    MeetingStage = "meetingStage",
}

export enum SupportedSharePointHosts {
    SharePointFullPage = "sharePointFullPage",
    SharePointWebPart = "sharePointWebPart",
}

export enum Scopes3 {
    Team = "team",
    Personal = "personal",
    GroupChat = "groupChat",
}

export enum Context2 {
    PersonalTab = "personalTab",
    ChannelTab = "channelTab",
    PrivateChatTab = "privateChatTab",
    MeetingChatTab = "meetingChatTab",
    MeetingDetailsTab = "meetingDetailsTab",
    MeetingSidePanel = "meetingSidePanel",
    MeetingStage = "meetingStage",
    TeamLevelApp = "teamLevelApp",
}

export class Configuration implements IConfiguration {
    team!: Team;
    groupChat!: Team;

    constructor(data?: IConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"] ? Team.fromJS(_data["team"]) : <any>undefined;
            this.groupChat = _data["groupChat"] ? Team.fromJS(_data["groupChat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Configuration {
        data = typeof data === 'object' ? data : {};
        let result = new Configuration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["groupChat"] = this.groupChat ? this.groupChat.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfiguration {
    team: Team;
    groupChat: Team;
}

export enum Scopes4 {
    Team = "team",
    Personal = "personal",
    GroupChat = "groupChat",
}

export class CommandLists implements ICommandLists {
    /** Specifies the scopes for which the command list is valid */
    scopes!: Scopes6[];
    commands!: Commands2[];

    constructor(data?: ICommandLists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.scopes = [];
            this.commands = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            if (Array.isArray(_data["commands"])) {
                this.commands = [] as any;
                for (let item of _data["commands"])
                    this.commands!.push(Commands2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommandLists {
        data = typeof data === 'object' ? data : {};
        let result = new CommandLists();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        if (Array.isArray(this.commands)) {
            data["commands"] = [];
            for (let item of this.commands)
                data["commands"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommandLists {
    /** Specifies the scopes for which the command list is valid */
    scopes: Scopes6[];
    commands: Commands2[];
}

export enum Scopes5 {
    Team = "team",
}

export enum ComposeExtensionsComposeExtensionType {
    BotBased = "botBased",
    ApiBased = "apiBased",
}

export class Authorization2 implements IAuthorization2 {
    /** Enum of possible authentication types. */
    authType!: Authorization2AuthType;
    /** Object capturing details needed to do single aad auth flow. It will be only present when auth type is entraId. */
    microsoftEntraConfiguration!: MicrosoftEntraConfiguration;
    /** Object capturing details needed to do service auth. It will be only present when auth type is apiSecretServiceAuth. */
    apiSecretServiceAuthConfiguration!: ApiSecretServiceAuthConfiguration;

    constructor(data?: IAuthorization2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authType = _data["authType"];
            this.microsoftEntraConfiguration = _data["microsoftEntraConfiguration"] ? MicrosoftEntraConfiguration.fromJS(_data["microsoftEntraConfiguration"]) : <any>undefined;
            this.apiSecretServiceAuthConfiguration = _data["apiSecretServiceAuthConfiguration"] ? ApiSecretServiceAuthConfiguration.fromJS(_data["apiSecretServiceAuthConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Authorization2 {
        data = typeof data === 'object' ? data : {};
        let result = new Authorization2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authType"] = this.authType;
        data["microsoftEntraConfiguration"] = this.microsoftEntraConfiguration ? this.microsoftEntraConfiguration.toJSON() : <any>undefined;
        data["apiSecretServiceAuthConfiguration"] = this.apiSecretServiceAuthConfiguration ? this.apiSecretServiceAuthConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthorization2 {
    /** Enum of possible authentication types. */
    authType: Authorization2AuthType;
    /** Object capturing details needed to do single aad auth flow. It will be only present when auth type is entraId. */
    microsoftEntraConfiguration: MicrosoftEntraConfiguration;
    /** Object capturing details needed to do service auth. It will be only present when auth type is apiSecretServiceAuth. */
    apiSecretServiceAuthConfiguration: ApiSecretServiceAuthConfiguration;
}

export class Commands implements ICommands {
    /** Id of the command. */
    id!: string;
    /** Type of the command */
    type!: CommandsType;
    samplePrompts!: SamplePrompts[];
    /** A relative file path for api response rendering template file. */
    apiResponseRenderingTemplateFile!: string;
    /** Context where the command would apply */
    context!: Context3[];
    /** Title of the command. */
    title!: string;
    /** Description of the command. */
    description!: string;
    /** A boolean value that indicates if the command should be run once initially with no parameter. */
    initialRun!: boolean;
    /** A boolean value that indicates if it should fetch task module dynamically */
    fetchTask!: boolean;
    /** Semantic description for the command. */
    semanticDescription!: string;
    parameters!: Parameters[];
    taskInfo!: TaskInfo;

    constructor(data?: ICommands) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = CommandsType.Query;
            this.initialRun = false;
            this.fetchTask = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] !== undefined ? _data["type"] : CommandsType.Query;
            if (Array.isArray(_data["samplePrompts"])) {
                this.samplePrompts = [] as any;
                for (let item of _data["samplePrompts"])
                    this.samplePrompts!.push(SamplePrompts.fromJS(item));
            }
            this.apiResponseRenderingTemplateFile = _data["apiResponseRenderingTemplateFile"];
            if (Array.isArray(_data["context"])) {
                this.context = [] as any;
                for (let item of _data["context"])
                    this.context!.push(item);
            }
            this.title = _data["title"];
            this.description = _data["description"];
            this.initialRun = _data["initialRun"] !== undefined ? _data["initialRun"] : false;
            this.fetchTask = _data["fetchTask"] !== undefined ? _data["fetchTask"] : false;
            this.semanticDescription = _data["semanticDescription"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(Parameters.fromJS(item));
            }
            this.taskInfo = _data["taskInfo"] ? TaskInfo.fromJS(_data["taskInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Commands {
        data = typeof data === 'object' ? data : {};
        let result = new Commands();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        if (Array.isArray(this.samplePrompts)) {
            data["samplePrompts"] = [];
            for (let item of this.samplePrompts)
                data["samplePrompts"].push(item.toJSON());
        }
        data["apiResponseRenderingTemplateFile"] = this.apiResponseRenderingTemplateFile;
        if (Array.isArray(this.context)) {
            data["context"] = [];
            for (let item of this.context)
                data["context"].push(item);
        }
        data["title"] = this.title;
        data["description"] = this.description;
        data["initialRun"] = this.initialRun;
        data["fetchTask"] = this.fetchTask;
        data["semanticDescription"] = this.semanticDescription;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommands {
    /** Id of the command. */
    id: string;
    /** Type of the command */
    type: CommandsType;
    samplePrompts: SamplePrompts[];
    /** A relative file path for api response rendering template file. */
    apiResponseRenderingTemplateFile: string;
    /** Context where the command would apply */
    context: Context3[];
    /** Title of the command. */
    title: string;
    /** Description of the command. */
    description: string;
    /** A boolean value that indicates if the command should be run once initially with no parameter. */
    initialRun: boolean;
    /** A boolean value that indicates if it should fetch task module dynamically */
    fetchTask: boolean;
    /** Semantic description for the command. */
    semanticDescription: string;
    parameters: Parameters[];
    taskInfo: TaskInfo;
}

export class MessageHandlers implements IMessageHandlers {
    /** Type of the message handler */
    type!: MessageHandlersType;
    value!: Value;

    constructor(data?: IMessageHandlers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = new Value();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"] ? Value.fromJS(_data["value"]) : new Value();
        }
    }

    static fromJS(data: any): MessageHandlers {
        data = typeof data === 'object' ? data : {};
        let result = new MessageHandlers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMessageHandlers {
    /** Type of the message handler */
    type: MessageHandlersType;
    value: Value;
}

export class ActivityTypes implements IActivityTypes {
    type!: string;
    description!: string;
    templateText!: string;

    constructor(data?: IActivityTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.description = _data["description"];
            this.templateText = _data["templateText"];
        }
    }

    static fromJS(data: any): ActivityTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["description"] = this.description;
        data["templateText"] = this.templateText;
        return data;
    }
}

export interface IActivityTypes {
    type: string;
    description: string;
    templateText: string;
}

export enum DefaultGroupCapabilityTeam {
    Tab = "tab",
    Bot = "bot",
    Connector = "connector",
}

export enum DefaultGroupCapabilityGroupchat {
    Tab = "tab",
    Bot = "bot",
    Connector = "connector",
}

export enum DefaultGroupCapabilityMeetings {
    Tab = "tab",
    Bot = "bot",
    Connector = "connector",
}

export class Scenes implements IScenes {
    /** A unique identifier for this scene. This id must be a GUID. */
    id!: string;
    /** Scene name. */
    name!: string;
    /** A relative file path to a scene metadata json file. */
    file!: string;
    /** A relative file path to a scene PNG preview icon. */
    preview!: string;
    /** Maximum audiences supported in scene. */
    maxAudience!: number;
    /** Number of seats reserved for organizers or presenters. */
    seatsReservedForOrganizersOrPresenters!: number;

    constructor(data?: IScenes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.preview = _data["preview"];
            this.maxAudience = _data["maxAudience"];
            this.seatsReservedForOrganizersOrPresenters = _data["seatsReservedForOrganizersOrPresenters"];
        }
    }

    static fromJS(data: any): Scenes {
        data = typeof data === 'object' ? data : {};
        let result = new Scenes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["file"] = this.file;
        data["preview"] = this.preview;
        data["maxAudience"] = this.maxAudience;
        data["seatsReservedForOrganizersOrPresenters"] = this.seatsReservedForOrganizersOrPresenters;
        return data;
    }
}

export interface IScenes {
    /** A unique identifier for this scene. This id must be a GUID. */
    id: string;
    /** Scene name. */
    name: string;
    /** A relative file path to a scene metadata json file. */
    file: string;
    /** A relative file path to a scene PNG preview icon. */
    preview: string;
    /** Maximum audiences supported in scene. */
    maxAudience: number;
    /** Number of seats reserved for organizers or presenters. */
    seatsReservedForOrganizersOrPresenters: number;
}

export class Permissions2 implements IPermissions2 {
    /** Permissions that must be granted on a per resource instance basis. */
    resourceSpecific!: ResourceSpecific[];

    constructor(data?: IPermissions2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resourceSpecific"])) {
                this.resourceSpecific = [] as any;
                for (let item of _data["resourceSpecific"])
                    this.resourceSpecific!.push(ResourceSpecific.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Permissions2 {
        data = typeof data === 'object' ? data : {};
        let result = new Permissions2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceSpecific)) {
            data["resourceSpecific"] = [];
            for (let item of this.resourceSpecific)
                data["resourceSpecific"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissions2 {
    /** Permissions that must be granted on a per resource instance basis. */
    resourceSpecific: ResourceSpecific[];
}

/** A runtime environment for a page or script */
export class Runtimes implements IRuntimes {
    requirements!: RequirementsExtensionElement;
    /** A unique identifier for this runtime within the app.  Maximum length is 64 characters. */
    id!: string;
    /** Supports running functions and launching pages. */
    type!: RuntimesType;
    code!: ExtensionRuntimeCode;
    /** Runtimes with a short lifetime do not preserve state across executions. Runtimes with a long lifetime do. */
    lifetime!: RuntimesLifetime;
    actions!: ExtensionRuntimesActionsItem[];

    constructor(data?: IRuntimes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.type = RuntimesType.General;
            this.code = new ExtensionRuntimeCode();
            this.lifetime = RuntimesLifetime.Short;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            this.id = _data["id"];
            this.type = _data["type"] !== undefined ? _data["type"] : RuntimesType.General;
            this.code = _data["code"] ? ExtensionRuntimeCode.fromJS(_data["code"]) : new ExtensionRuntimeCode();
            this.lifetime = _data["lifetime"] !== undefined ? _data["lifetime"] : RuntimesLifetime.Short;
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ExtensionRuntimesActionsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Runtimes {
        data = typeof data === 'object' ? data : {};
        let result = new Runtimes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["type"] = this.type;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["lifetime"] = this.lifetime;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

/** A runtime environment for a page or script */
export interface IRuntimes {
    requirements: RequirementsExtensionElement;
    /** A unique identifier for this runtime within the app.  Maximum length is 64 characters. */
    id: string;
    /** Supports running functions and launching pages. */
    type: RuntimesType;
    code: ExtensionRuntimeCode;
    /** Runtimes with a short lifetime do not preserve state across executions. Runtimes with a long lifetime do. */
    lifetime: RuntimesLifetime;
    actions: ExtensionRuntimesActionsItem[];
}

export class Ribbons implements IRibbons {
    requirements!: RequirementsExtensionElement;
    contexts!: Contexts[];
    tabs!: ExtensionRibbonsArrayTabsItem[];

    constructor(data?: IRibbons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tabs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            if (Array.isArray(_data["contexts"])) {
                this.contexts = [] as any;
                for (let item of _data["contexts"])
                    this.contexts!.push(item);
            }
            if (Array.isArray(_data["tabs"])) {
                this.tabs = [] as any;
                for (let item of _data["tabs"])
                    this.tabs!.push(ExtensionRibbonsArrayTabsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Ribbons {
        data = typeof data === 'object' ? data : {};
        let result = new Ribbons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        if (Array.isArray(this.contexts)) {
            data["contexts"] = [];
            for (let item of this.contexts)
                data["contexts"].push(item);
        }
        if (Array.isArray(this.tabs)) {
            data["tabs"] = [];
            for (let item of this.tabs)
                data["tabs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRibbons {
    requirements: RequirementsExtensionElement;
    contexts: Contexts[];
    tabs: ExtensionRibbonsArrayTabsItem[];
}

export class AutoRunEvents implements IAutoRunEvents {
    requirements!: RequirementsExtensionElement;
    /** Specifies the type of event. For supported types, please see: https://review.learn.microsoft.com/en-us/office/dev/add-ins/outlook/autolaunch?tabs=xmlmanifest#supported-events. */
    events!: Events[];

    constructor(data?: IAutoRunEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.events = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(Events.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoRunEvents {
        data = typeof data === 'object' ? data : {};
        let result = new AutoRunEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAutoRunEvents {
    requirements: RequirementsExtensionElement;
    /** Specifies the type of event. For supported types, please see: https://review.learn.microsoft.com/en-us/office/dev/add-ins/outlook/autolaunch?tabs=xmlmanifest#supported-events. */
    events: Events[];
}

export class Alternates implements IAlternates {
    requirements!: RequirementsExtensionElement;
    prefer!: Prefer;
    hide!: Hide;
    alternateIcons!: AlternateIcons;

    constructor(data?: IAlternates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            this.prefer = _data["prefer"] ? Prefer.fromJS(_data["prefer"]) : <any>undefined;
            this.hide = _data["hide"] ? Hide.fromJS(_data["hide"]) : <any>undefined;
            this.alternateIcons = _data["alternateIcons"] ? AlternateIcons.fromJS(_data["alternateIcons"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Alternates {
        data = typeof data === 'object' ? data : {};
        let result = new Alternates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        data["prefer"] = this.prefer ? this.prefer.toJSON() : <any>undefined;
        data["hide"] = this.hide ? this.hide.toJSON() : <any>undefined;
        data["alternateIcons"] = this.alternateIcons ? this.alternateIcons.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlternates {
    requirements: RequirementsExtensionElement;
    prefer: Prefer;
    hide: Hide;
    alternateIcons: AlternateIcons;
}

export class ContentRuntimes implements IContentRuntimes {
    requirements!: RequirementsExtensionElement;
    /** A unique identifier for this runtime within the app. This is developer specified. */
    id!: string;
    code!: ExtensionRuntimeCode;
    /** The desired height in pixels for the initial content placeholder. This value MUST be between 32 and 1000 pixels. Default value will be determined by host. */
    requestedHeight!: number;
    /** The desired width in pixels for the initial content placeholder. This value MUST be between 32 and 1000 pixels. Default value will be determined by host. */
    requestedWidth!: number;
    /** Specifies whether a snapshot image of your content add-in is saved with the host document. Default value is false. Set true to disable. */
    disableSnapshot!: boolean;

    constructor(data?: IContentRuntimes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = new ExtensionRuntimeCode();
            this.disableSnapshot = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            this.id = _data["id"];
            this.code = _data["code"] ? ExtensionRuntimeCode.fromJS(_data["code"]) : new ExtensionRuntimeCode();
            this.requestedHeight = _data["requestedHeight"];
            this.requestedWidth = _data["requestedWidth"];
            this.disableSnapshot = _data["disableSnapshot"] !== undefined ? _data["disableSnapshot"] : false;
        }
    }

    static fromJS(data: any): ContentRuntimes {
        data = typeof data === 'object' ? data : {};
        let result = new ContentRuntimes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["requestedHeight"] = this.requestedHeight;
        data["requestedWidth"] = this.requestedWidth;
        data["disableSnapshot"] = this.disableSnapshot;
        return data;
    }
}

export interface IContentRuntimes {
    requirements: RequirementsExtensionElement;
    /** A unique identifier for this runtime within the app. This is developer specified. */
    id: string;
    code: ExtensionRuntimeCode;
    /** The desired height in pixels for the initial content placeholder. This value MUST be between 32 and 1000 pixels. Default value will be determined by host. */
    requestedHeight: number;
    /** The desired width in pixels for the initial content placeholder. This value MUST be between 32 and 1000 pixels. Default value will be determined by host. */
    requestedWidth: number;
    /** Specifies whether a snapshot image of your content add-in is saved with the host document. Default value is false. Set true to disable. */
    disableSnapshot: boolean;
}

export class GetStartedMessages implements IGetStartedMessages {
    requirements!: RequirementsExtensionElement;
    /** The title used for the top of the callout. */
    title!: string;
    /** The description/body content for the callout. */
    description!: string;
    /** A URL to a page that explains the add-in in detail. */
    learnMoreUrl!: string;

    constructor(data?: IGetStartedMessages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.learnMoreUrl = _data["learnMoreUrl"];
        }
    }

    static fromJS(data: any): GetStartedMessages {
        data = typeof data === 'object' ? data : {};
        let result = new GetStartedMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["learnMoreUrl"] = this.learnMoreUrl;
        return data;
    }
}

export interface IGetStartedMessages {
    requirements: RequirementsExtensionElement;
    /** The title used for the top of the callout. */
    title: string;
    /** The description/body content for the callout. */
    description: string;
    /** A URL to a page that explains the add-in in detail. */
    learnMoreUrl: string;
}

export class ContextMenus implements IContextMenus {
    requirements!: RequirementsExtensionElement;
    menus!: Menus[];

    constructor(data?: IContextMenus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.menus = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirements = _data["requirements"] ? RequirementsExtensionElement.fromJS(_data["requirements"]) : <any>undefined;
            if (Array.isArray(_data["menus"])) {
                this.menus = [] as any;
                for (let item of _data["menus"])
                    this.menus!.push(Menus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContextMenus {
        data = typeof data === 'object' ? data : {};
        let result = new ContextMenus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirements"] = this.requirements ? this.requirements.toJSON() : <any>undefined;
        if (Array.isArray(this.menus)) {
            data["menus"] = [];
            for (let item of this.menus)
                data["menus"].push(item.toJSON());
        }
        return data;
    }
}

export interface IContextMenus {
    requirements: RequirementsExtensionElement;
    menus: Menus[];
}

export class Team implements ITeam {
    fetchTask!: boolean;
    taskInfo!: TaskInfo;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fetchTask = _data["fetchTask"];
            this.taskInfo = _data["taskInfo"] ? TaskInfo.fromJS(_data["taskInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fetchTask"] = this.fetchTask;
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeam {
    fetchTask: boolean;
    taskInfo: TaskInfo;
}

export enum Scopes6 {
    Team = "team",
    Personal = "personal",
    GroupChat = "groupChat",
}

export class Commands2 implements ICommands2 {
    /** The bot command name */
    title!: string;
    /** A simple text description or an example of the command syntax and its arguments. */
    description!: string;

    constructor(data?: ICommands2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Commands2 {
        data = typeof data === 'object' ? data : {};
        let result = new Commands2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        return data;
    }
}

export interface ICommands2 {
    /** The bot command name */
    title: string;
    /** A simple text description or an example of the command syntax and its arguments. */
    description: string;
}

export enum Authorization2AuthType {
    None = "none",
    ApiSecretServiceAuth = "apiSecretServiceAuth",
    MicrosoftEntra = "microsoftEntra",
}

export class MicrosoftEntraConfiguration implements IMicrosoftEntraConfiguration {
    /** Boolean indicating whether single sign on is configured for the app. */
    supportsSingleSignOn!: boolean;

    constructor(data?: IMicrosoftEntraConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.supportsSingleSignOn = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supportsSingleSignOn = _data["supportsSingleSignOn"] !== undefined ? _data["supportsSingleSignOn"] : false;
        }
    }

    static fromJS(data: any): MicrosoftEntraConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftEntraConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportsSingleSignOn"] = this.supportsSingleSignOn;
        return data;
    }
}

export interface IMicrosoftEntraConfiguration {
    /** Boolean indicating whether single sign on is configured for the app. */
    supportsSingleSignOn: boolean;
}

export class ApiSecretServiceAuthConfiguration implements IApiSecretServiceAuthConfiguration {
    /** Registration id returned when developer submits the api key through Developer Portal. */
    apiSecretRegistrationId!: string;

    constructor(data?: IApiSecretServiceAuthConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiSecretRegistrationId = _data["apiSecretRegistrationId"];
        }
    }

    static fromJS(data: any): ApiSecretServiceAuthConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSecretServiceAuthConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiSecretRegistrationId"] = this.apiSecretRegistrationId;
        return data;
    }
}

export interface IApiSecretServiceAuthConfiguration {
    /** Registration id returned when developer submits the api key through Developer Portal. */
    apiSecretRegistrationId: string;
}

export enum CommandsType {
    Query = "query",
    Action = "action",
}

export class SamplePrompts implements ISamplePrompts {
    /** This string will hold the sample prompt */
    text!: string;

    constructor(data?: ISamplePrompts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SamplePrompts {
        data = typeof data === 'object' ? data : {};
        let result = new SamplePrompts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface ISamplePrompts {
    /** This string will hold the sample prompt */
    text: string;
}

export enum Context3 {
    Compose = "compose",
    CommandBox = "commandBox",
    Message = "message",
}

export class Parameters implements IParameters {
    /** Name of the parameter. */
    name!: string;
    /** Type of the parameter */
    inputType!: ParametersInputType;
    /** Title of the parameter. */
    title!: string;
    /** Description of the parameter. */
    description!: string;
    /** Initial value for the parameter */
    value!: string;
    /** The value indicates if this parameter is a required field. */
    isRequired!: boolean;
    /** Semantic description for the parameter. */
    semanticDescription!: string;
    /** The choice options for the parameter */
    choices!: Choices[];

    constructor(data?: IParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.inputType = ParametersInputType.Text;
            this.isRequired = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.inputType = _data["inputType"] !== undefined ? _data["inputType"] : ParametersInputType.Text;
            this.title = _data["title"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.isRequired = _data["isRequired"] !== undefined ? _data["isRequired"] : false;
            this.semanticDescription = _data["semanticDescription"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(Choices.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Parameters {
        data = typeof data === 'object' ? data : {};
        let result = new Parameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["inputType"] = this.inputType;
        data["title"] = this.title;
        data["description"] = this.description;
        data["value"] = this.value;
        data["isRequired"] = this.isRequired;
        data["semanticDescription"] = this.semanticDescription;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IParameters {
    /** Name of the parameter. */
    name: string;
    /** Type of the parameter */
    inputType: ParametersInputType;
    /** Title of the parameter. */
    title: string;
    /** Description of the parameter. */
    description: string;
    /** Initial value for the parameter */
    value: string;
    /** The value indicates if this parameter is a required field. */
    isRequired: boolean;
    /** Semantic description for the parameter. */
    semanticDescription: string;
    /** The choice options for the parameter */
    choices: Choices[];
}

export class TaskInfo implements ITaskInfo {
    /** Initial dialog title */
    title!: string;
    /** Dialog width - either a number in pixels or default layout such as 'large', 'medium', or 'small' */
    width!: string;
    /** Dialog height - either a number in pixels or default layout such as 'large', 'medium', or 'small' */
    height!: string;
    /** Initial webview URL */
    url!: string;

    constructor(data?: ITaskInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TaskInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["width"] = this.width;
        data["height"] = this.height;
        data["url"] = this.url;
        return data;
    }
}

export interface ITaskInfo {
    /** Initial dialog title */
    title: string;
    /** Dialog width - either a number in pixels or default layout such as 'large', 'medium', or 'small' */
    width: string;
    /** Dialog height - either a number in pixels or default layout such as 'large', 'medium', or 'small' */
    height: string;
    /** Initial webview URL */
    url: string;
}

export enum MessageHandlersType {
    Link = "link",
}

export class Value implements IValue {
    /** A list of domains that the link message handler can register for, and when they are matched the app will be invoked */
    domains!: string[];
    /** A boolean that indicates whether the app's link message handler supports anonymous invoke flow. */
    supportsAnonymizedPayloads!: boolean;

    constructor(data?: IValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.supportsAnonymizedPayloads = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(item);
            }
            this.supportsAnonymizedPayloads = _data["supportsAnonymizedPayloads"] !== undefined ? _data["supportsAnonymizedPayloads"] : false;
        }
    }

    static fromJS(data: any): Value {
        data = typeof data === 'object' ? data : {};
        let result = new Value();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item);
        }
        data["supportsAnonymizedPayloads"] = this.supportsAnonymizedPayloads;
        return data;
    }
}

export interface IValue {
    /** A list of domains that the link message handler can register for, and when they are matched the app will be invoked */
    domains: string[];
    /** A boolean that indicates whether the app's link message handler supports anonymous invoke flow. */
    supportsAnonymizedPayloads: boolean;
}

export class ResourceSpecific implements IResourceSpecific {
    /** The name of the resource-specific permission. */
    name!: string;
    /** The type of the resource-specific permission: delegated vs application. */
    type!: ResourceSpecificType;

    constructor(data?: IResourceSpecific) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ResourceSpecific {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceSpecific();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IResourceSpecific {
    /** The name of the resource-specific permission. */
    name: string;
    /** The type of the resource-specific permission: delegated vs application. */
    type: ResourceSpecificType;
}

export enum RuntimesType {
    General = "general",
}

export enum RuntimesLifetime {
    Short = "short",
    Long = "long",
}

export enum Contexts {
    MailRead = "mailRead",
    MailCompose = "mailCompose",
    MeetingDetailsOrganizer = "meetingDetailsOrganizer",
    MeetingDetailsAttendee = "meetingDetailsAttendee",
    OnlineMeetingDetailsOrganizer = "onlineMeetingDetailsOrganizer",
    LogEventMeetingDetailsAttendee = "logEventMeetingDetailsAttendee",
    Default = "default",
}

export class Events implements IEvents {
    type!: string;
    /** The ID of an action defined in runtimes. Maximum length is 64 characters. */
    actionId!: string;
    /** Configures how Outlook responds to the event. */
    options!: Options;

    constructor(data?: IEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.actionId = _data["actionId"];
            this.options = _data["options"] ? Options.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Events {
        data = typeof data === 'object' ? data : {};
        let result = new Events();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["actionId"] = this.actionId;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEvents {
    type: string;
    /** The ID of an action defined in runtimes. Maximum length is 64 characters. */
    actionId: string;
    /** Configures how Outlook responds to the event. */
    options: Options;
}

export class Prefer implements IPrefer {
    comAddin!: ComAddin;
    xllCustomFunctions!: XllCustomFunctions;

    constructor(data?: IPrefer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comAddin = _data["comAddin"] ? ComAddin.fromJS(_data["comAddin"]) : <any>undefined;
            this.xllCustomFunctions = _data["xllCustomFunctions"] ? XllCustomFunctions.fromJS(_data["xllCustomFunctions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Prefer {
        data = typeof data === 'object' ? data : {};
        let result = new Prefer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comAddin"] = this.comAddin ? this.comAddin.toJSON() : <any>undefined;
        data["xllCustomFunctions"] = this.xllCustomFunctions ? this.xllCustomFunctions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrefer {
    comAddin: ComAddin;
    xllCustomFunctions: XllCustomFunctions;
}

export class Hide implements IHide {
    storeOfficeAddin!: StoreOfficeAddin;
    customOfficeAddin!: CustomOfficeAddin;

    constructor(data?: IHide) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeOfficeAddin = _data["storeOfficeAddin"] ? StoreOfficeAddin.fromJS(_data["storeOfficeAddin"]) : <any>undefined;
            this.customOfficeAddin = _data["customOfficeAddin"] ? CustomOfficeAddin.fromJS(_data["customOfficeAddin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Hide {
        data = typeof data === 'object' ? data : {};
        let result = new Hide();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeOfficeAddin"] = this.storeOfficeAddin ? this.storeOfficeAddin.toJSON() : <any>undefined;
        data["customOfficeAddin"] = this.customOfficeAddin ? this.customOfficeAddin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHide {
    storeOfficeAddin: StoreOfficeAddin;
    customOfficeAddin: CustomOfficeAddin;
}

export class AlternateIcons implements IAlternateIcons {
    icon!: ExtensionCommonIcon;
    highResolutionIcon!: ExtensionCommonIcon;

    constructor(data?: IAlternateIcons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.icon = new ExtensionCommonIcon();
            this.highResolutionIcon = new ExtensionCommonIcon();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"] ? ExtensionCommonIcon.fromJS(_data["icon"]) : new ExtensionCommonIcon();
            this.highResolutionIcon = _data["highResolutionIcon"] ? ExtensionCommonIcon.fromJS(_data["highResolutionIcon"]) : new ExtensionCommonIcon();
        }
    }

    static fromJS(data: any): AlternateIcons {
        data = typeof data === 'object' ? data : {};
        let result = new AlternateIcons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        data["highResolutionIcon"] = this.highResolutionIcon ? this.highResolutionIcon.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAlternateIcons {
    icon: ExtensionCommonIcon;
    highResolutionIcon: ExtensionCommonIcon;
}

export class Menus implements IMenus {
    /** Use text or cell here for Office context menu. Use text if the context menu should open when a user right-clicks on the selected text. Use cell if the context menu should open when the user right-clicks on a cell on an Excel spreadsheet. */
    entryPoint!: MenusEntryPoint;
    controls!: ExtensionCommonCustomGroupControlsItem[];

    constructor(data?: IMenus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.controls = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryPoint = _data["entryPoint"];
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(ExtensionCommonCustomGroupControlsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Menus {
        data = typeof data === 'object' ? data : {};
        let result = new Menus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryPoint"] = this.entryPoint;
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMenus {
    /** Use text or cell here for Office context menu. Use text if the context menu should open when a user right-clicks on the selected text. Use cell if the context menu should open when the user right-clicks on a cell on an Excel spreadsheet. */
    entryPoint: MenusEntryPoint;
    controls: ExtensionCommonCustomGroupControlsItem[];
}

export enum ParametersInputType {
    Text = "text",
    Textarea = "textarea",
    Number = "number",
    Date = "date",
    Time = "time",
    Toggle = "toggle",
    Choiceset = "choiceset",
}

export class Choices implements IChoices {
    /** Title of the choice */
    title!: string;
    /** Value of the choice */
    value!: string;

    constructor(data?: IChoices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Choices {
        data = typeof data === 'object' ? data : {};
        let result = new Choices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["value"] = this.value;
        return data;
    }
}

export interface IChoices {
    /** Title of the choice */
    title: string;
    /** Value of the choice */
    value: string;
}

export enum ResourceSpecificType {
    Application = "Application",
    Delegated = "Delegated",
}

export class Options implements IOptions {
    sendMode!: OptionsSendMode;

    constructor(data?: IOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendMode = _data["sendMode"];
        }
    }

    static fromJS(data: any): Options {
        data = typeof data === 'object' ? data : {};
        let result = new Options();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendMode"] = this.sendMode;
        return data;
    }
}

export interface IOptions {
    sendMode: OptionsSendMode;
}

export class ComAddin implements IComAddin {
    /** Program ID of the alternate com extension. Maximum length is 64 characters. */
    progId!: string;

    constructor(data?: IComAddin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.progId = _data["progId"];
        }
    }

    static fromJS(data: any): ComAddin {
        data = typeof data === 'object' ? data : {};
        let result = new ComAddin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["progId"] = this.progId;
        return data;
    }
}

export interface IComAddin {
    /** Program ID of the alternate com extension. Maximum length is 64 characters. */
    progId: string;
}

export class XllCustomFunctions implements IXllCustomFunctions {
    /** File name for the XLL extension. Maximum length is 64 characters. */
    fileName!: string;

    constructor(data?: IXllCustomFunctions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): XllCustomFunctions {
        data = typeof data === 'object' ? data : {};
        let result = new XllCustomFunctions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IXllCustomFunctions {
    /** File name for the XLL extension. Maximum length is 64 characters. */
    fileName: string;
}

export class StoreOfficeAddin implements IStoreOfficeAddin {
    /** Solution ID of an in-market add-in to hide. Maximum length is 64 characters. */
    officeAddinId!: string;
    /** Asset ID of the in-market add-in to hide. Maximum length is 64 characters. */
    assetId!: string;

    constructor(data?: IStoreOfficeAddin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeAddinId = _data["officeAddinId"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): StoreOfficeAddin {
        data = typeof data === 'object' ? data : {};
        let result = new StoreOfficeAddin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeAddinId"] = this.officeAddinId;
        data["assetId"] = this.assetId;
        return data;
    }
}

export interface IStoreOfficeAddin {
    /** Solution ID of an in-market add-in to hide. Maximum length is 64 characters. */
    officeAddinId: string;
    /** Asset ID of the in-market add-in to hide. Maximum length is 64 characters. */
    assetId: string;
}

export class CustomOfficeAddin implements ICustomOfficeAddin {
    /** Solution ID of the in-market add-in to hide. Maximum length is 64 characters. */
    officeAddinId!: string;

    constructor(data?: ICustomOfficeAddin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.officeAddinId = _data["officeAddinId"];
        }
    }

    static fromJS(data: any): CustomOfficeAddin {
        data = typeof data === 'object' ? data : {};
        let result = new CustomOfficeAddin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["officeAddinId"] = this.officeAddinId;
        return data;
    }
}

export interface ICustomOfficeAddin {
    /** Solution ID of the in-market add-in to hide. Maximum length is 64 characters. */
    officeAddinId: string;
}

export enum MenusEntryPoint {
    Text = "text",
    Cell = "cell",
}

export enum OptionsSendMode {
    PromptUser = "promptUser",
    SoftBlock = "softBlock",
    Block = "block",
}